{
  "createHub": {
    "title": "Создать",
    "open": "Создать",
    "close": "Закрыть",
    "actionsHeader": "Начать",
    "newWorkout": {
      "title": "Новая тренировка",
      "sub": "Начать пустую тренировку сейчас"
    },
    "repeatWorkout": {
      "title": "Повторить тренировку",
      "sub": "Записать снова из прошлой тренировки"
    },
    "planProgram": {
      "title": "Запланировать программу",
      "sub": "Создать многонедельную программу"
    },
    "planWorkout": {
      "title": "Запланировать тренировку",
      "sub": "Подготовить одну сессию на потом"
    }
  },
  "library": {
    "header": "Обзор",
    "tabPrograms": "Программы",
    "tabWorkouts": "Тренировки",
    "tabPersonal": "Мои",
    "tabCoach": "Тренер",
    "tabFavorites": "Избранное",
    "favoriteA11y": "В избранное",
    "errFavorite": "Не удалось обновить избранное.",
    "emptyFavoritesTitle": "Пока нет избранного",
    "emptyFavoritesSub": "Отметь программу или тренировку звездой, чтобы она была здесь.",
    "sectionOfficial": "От JackedLogs",
    "sectionPersonal": "Мои",
    "clone": "Клонировать",
    "copySuffix": "(копия)",
    "following": "Активация…",
    "searchPlaceholder": "Поиск по названию…",
    "filters": "Фильтры",
    "clearFilters": "Сбросить",
    "axisLevel": "Уровень",
    "axisPerWeek": "Тренировки / неделя",
    "noResultsTitle": "Ничего не найдено",
    "noResultsSub": "Измени поиск или фильтры.",
    "loading": "Загрузка библиотеки…",
    "errLoad": "Не удалось загрузить библиотеку.",
    "errClone": "Не удалось клонировать. Попробуй ещё раз.",
    "errDelete": "Не удалось удалить. Попробуй ещё раз.",
    "errFollow": "Не удалось начать следовать программе.",
    "errStatus": "Не удалось обновить программу.",
    "emptyTitle": "Пока здесь пусто",
    "emptySub": "Созданные или склонированные программы и тренировки появятся здесь.",
    "coachSoonTitle": "От тренера",
    "coachSoonSub": "Программы и тренировки, назначенные тренером, появятся здесь."
  },
  "common": {
    "lastDataAt": "Последние данные {{at}}",
    "languageA11y": "Язык",
    "infoA11y": "Информация",
    "unsavedChanges": {
      "title": "Отменить изменения?",
      "body": "Несохранённые изменения будут потеряны.",
      "keepEditing": "Продолжить редактирование",
      "discard": "Отменить"
    }
  },
  "bodymap": {
    "viewBack": "Спина",
    "viewFront": "Спереди",
    "workedTitle": "Задействованные мышцы",
    "workedPrimary": "основные",
    "workedSecondary": "вспомогательные",
    "heatmapTitle": "Самые нагруженные мышцы",
    "heatmapLow": "мало",
    "heatmapHigh": "много",
    "window7d": "7 дней",
    "window30d": "30 дней",
    "painTitle": "Карта боли",
    "painHelp": "Тап по мышце меняет статус: красный (избегать нагрузки), жёлтый (осторожно). Сохраняется автоматически.",
    "painRed": "избегать",
    "painYellow": "осторожно",
    "painClearAll": "Очистить всё",
    "painSaving": "Сохранение…",
    "painSaveError": "Сохранение не удалось. Проверьте подключение.",
    "painRiskA11y": "Риск боли: {{severity}}",
    "painSeverity": {
      "red": "высокий",
      "yellow": "средний",
      "green": "низкий"
    }
  },
  "plates": {
    "title": "Раскладка блинов",
    "openHint": "Показать раскладку",
    "close": "Закрыть",
    "targetLabel": "Цель",
    "barLabel": "Гриф",
    "barAria": "Вес грифа",
    "barNone": "Без грифа",
    "perSide": "На сторону",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Только гриф — блины не нужны.",
    "belowBar": "Цель легче грифа.",
    "invalidInput": "Сначала введи корректный вес.",
    "remainder": "+{{weight}} не хватает до цели с текущим инвентарём.",
    "fallbackPill": "максимум возможный",
    "inventoryLegend": "Доступные пары",
    "inventoryHint": "Пары каждого блина, доступные сейчас. 0, если в зале его нет или все заняты. Сохраняется между сессиями.",
    "pairsAria": "Пары {{plate}} доступны",
    "loadedEnd": "Нагруженный конец",
    "landmineHint": "Landmine: нагружен только свободный конец. Другой конец закреплён в напольном шарнире."
  },
  "app": {
    "title": "JackedLogs",
    "tagline": "Силовые тренировки, без лишнего.",
    "signedInAs": "Вы вошли как <bold>{{email}}</bold>.",
    "signOut": "Выйти",
    "loading": "Загрузка…",
    "checking": "проверка…"
  },
  "auth": {
    "signIn": "Войти",
    "signInFailed": "Не удалось войти. Проверь электронную почту и пароль.",
    "createAccount": "Создать аккаунт",
    "email": "Электронная почта",
    "emailPlaceholder": "email@example.com",
    "password": "Пароль",
    "passwordHint": "Не менее 10 символов: заглавная и строчная буквы и цифра.",
    "switchToSignUp": "Нет аккаунта? Создайте его.",
    "switchToSignIn": "Уже есть аккаунт? Войдите.",
    "submitting": "Подождите…",
    "confirmTitle": "Подтвердите электронную почту",
    "confirmCode": "Код подтверждения",
    "confirmHelp": "Мы отправили код на <bold>{{email}}</bold>. Вставьте его ниже, чтобы завершить регистрацию.",
    "confirmSubmit": "Подтвердить",
    "confirming": "Подтверждение…",
    "resendCode": "Отправить код снова",
    "resentInfo": "Код отправлен снова. Проверьте почту.",
    "confirmedNowSignIn": "Аккаунт подтверждён. Войдите, чтобы продолжить.",
    "forgotLink": "Забыли пароль?",
    "forgotTitle": "Сброс пароля",
    "forgotIntro": "Укажите email - мы вышлем код для сброса пароля.",
    "forgotSendCode": "Отправить код",
    "forgotCodeSent": "Код отправлен. Проверьте почту.",
    "forgotConfirmHelp": "Код отправлен на <bold>{{email}}</bold>. Введите его ниже вместе с новым паролем.",
    "forgotResetSubmit": "Сбросить пароль",
    "forgotResetDone": "Пароль обновлён. Войдите с новым паролем.",
    "newPassword": "Новый пароль",
    "backToSignIn": "Вернуться ко входу"
  },
  "dashboard": {
    "meTitle": "Аутентифицированный round-trip — /api/me",
    "healthTitle": "Состояние API",
    "exportData": "Экспортировать мои данные",
    "deleteAccount": "Удалить мой аккаунт",
    "exporting": "Подготовка экспорта…",
    "deleting": "Удаление…",
    "deleteConfirm": "Ваш аккаунт и все ваши данные будут окончательно удалены. Введите УДАЛИТЬ для подтверждения.",
    "deleteCancel": "Отмена",
    "deletePlaceholder": "УДАЛИТЬ",
    "deleteSuccess": "Аккаунт удалён.",
    "exportFilename": "jackedlogs-export-{{date}}.json",
    "privacyTitle": "Конфиденциальность",
    "privacyHelp": "Экспорт всех данных в JSON или полное удаление аккаунта. Удаление необратимо."
  },
  "privacy": {
    "linkLabel": "Конфиденциальность",
    "title": "Политика конфиденциальности",
    "lastUpdated": "Последнее обновление: 20 августа 2026 г. (правовая основа)",
    "intro": "JackedLogs создаётся и поддерживается одним человеком. Эта политика объясняет, какие данные мы собираем, где они хранятся и какие у вас права.",
    "section1Title": "Какие данные мы собираем",
    "section1Body": "Только то, что строго необходимо для работы сервиса: ваш адрес электронной почты (используется как идентификатор аккаунта), хешированный пароль (управляется Amazon Cognito — открытый текст никогда не покидает ваш браузер) и тренировочные данные, которые вы сами вводите. Мы не собираем имя, адрес, номер телефона, дату рождения или какие-либо аналитические отпечатки. Вес тела вводится по желанию: если вы укажете его в профиле, приложение сможет рассчитать эффективную нагрузку в упражнениях со своим весом (отжимания на брусьях, подтягивания и т. п.). Эти данные относятся к специальной категории сведений о состоянии здоровья по ст. 9 GDPR и ст. 5 пп. c швейцарского nLPD: никогда не агрегируются, не попадают в логи, удаляются вместе со всеми остальными данными при удалении аккаунта.",
    "section2Title": "Где хранятся данные",
    "section2Body": "Все данные хранятся в регионе AWS eu-central-2 (Цюрих, Швейцария). Аутентификация работает на Amazon Cognito; структурированные данные — на Amazon DynamoDB; статические ресурсы — на Amazon CloudFront. Мы не используем сторонние сервисы аналитики, рекламы или отслеживания.",
    "section3Title": "Ваши права",
    "section3Body": "В любой момент вы можете экспортировать весь набор своих данных (JSON) или окончательно удалить аккаунт через панель управления. Удаление стирает запись аутентификации и все записи, привязанные к вашему аккаунту, без возможности восстановления.",
    "section4Title": "Контакты",
    "section4Body": "Вопросы или запросы: {{email}}.",
    "section5Title": "Правовая основа",
    "section5Body": "Правовой основой обработки согласно швейцарскому nLPD и европейскому GDPR является ваше согласие при регистрации и законный интерес в предоставлении запрошенного сервиса. Мы обновим эту политику до любого расширения её применения.",
    "back": "Назад"
  },
  "errors": {
    "generic": "Что-то пошло не так."
  },
  "feedback": {
    "title": "Отправить отзыв",
    "help": "Нашёл баг, хочешь функцию или что-то ещё? Напиши здесь. Сообщения попадают в инбокс админа.",
    "kindLabel": "Тип",
    "kind_bug": "Баг",
    "kind_feature": "Запрос функции",
    "kind_other": "Другое",
    "bodyLabel": "Что произошло?",
    "bodyPlaceholder": "Опиши, что ты увидел, что ожидал и как это воспроизвести.",
    "send": "Отправить",
    "sending": "Отправка…",
    "sentFlash": "Спасибо — отправлено.",
    "sentHint": "Разберём в следующей сессии. Можно закрыть.",
    "close": "Закрыть",
    "errEmpty": "Напиши что-нибудь перед отправкой.",
    "errSubmit": "Не удалось отправить. Попробуй ещё раз позже.",
    "errRateLimit": "Слишком много отправлений за последний час. Попробуй позже.",
    "inboxTitle": "Инбокс отзывов",
    "loading": "Загрузка отзывов…",
    "empty": "Нет отзывов.",
    "filterAll": "Все",
    "loadMore": "Загрузить ещё",
    "status_open": "Открыт",
    "status_in_progress": "В работе",
    "status_shipped": "Готово",
    "status_wontfix": "Не будет исправлено",
    "priorityLabel": "Приоритет",
    "priorityNone": "Нет",
    "statusLabel": "Статус",
    "head_open": "{{count}} открыто",
    "head_in_progress": "{{count}} в работе",
    "head_shipped": "{{count}} готово",
    "head_wontfix": "{{count}} не будет исправлено",
    "headTotal": "{{count}} всего"
  },
  "profile": {
    "title": "Профиль",
    "loading": "Загрузка профиля…",
    "name": "Отображаемое имя",
    "namePlaceholder": "Как к вам обращаться?",
    "role": "Роль",
    "roleCoach": "Тренер",
    "roleAthlete": "Спортсмен",
    "roleBoth": "Оба",
    "ageBucket": "Возрастная группа (необязательно)",
    "ageBucketHelp": "Используется только для добровольной анонимной групповой статистики. Если не выбрать, останется пустым.",
    "ageBucketNone": "Предпочитаю не указывать",
    "unitsPreference": "Предпочитаемые единицы",
    "unitsPreferenceHelp": "Веса всегда сохраняются в килограммах. Для каждого подхода можно выбрать другую единицу ввода.",
    "preferredFigure": "Фигура тела на body map",
    "preferredFigureHelp": "Выберите фигуру, которой отрисовывается muscle map. Не связано с полом — мы не спрашиваем. Веб пока показывает только мужскую фигуру до смены библиотеки; на мобильном поддержаны обе.",
    "figure_masculine": "Мужская",
    "figure_feminine": "Женская",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Профиль сохранён.",
    "agePrefix_under_18": "До 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Вес тела (необязательно)",
    "bodyweightPlaceholder": "напр. 78",
    "bodyweightHelp": "Используется только для расчёта эффективной нагрузки в упражнениях со своим весом. Никогда не агрегируется, не попадает в логи, удаляется вместе с аккаунтом.",
    "errBodyweight": "Введите вес от 20 до 300 кг (или эквивалент в lb).",
    "apk": {
      "title": "Android APK (тестовая сборка)",
      "hint": "Тестовая сборка только для семьи. На Android включите «Установка из неизвестных источников» в браузере и откройте файл.",
      "download": "Скачать APK"
    },
    "email": "Эл. почта",
    "metaTitle": "Сессия"
  },
  "workout": {
    "title": "Тренировки",
    "loading": "Загрузка тренировок…",
    "empty": "Тренировок пока нет.",
    "logNew": "Записать тренировку",
    "startedAt": "Когда",
    "exercise": "Упражнение",
    "exercisePlaceholder": "Выберите упражнение",
    "errPickExercise": "Выберите упражнение из каталога.",
    "catalogEmptyCoach": "Каталог пуст. Добавьте хотя бы одно упражнение, прежде чем записывать тренировку.",
    "catalogEmptyAthlete": "Каталог пуст. Один из ваших тренеров должен добавить упражнения, прежде чем вы сможете записать тренировку.",
    "setsLegend": "Подходы",
    "set": "Подход",
    "reps": "Повторы",
    "amrapHint": "AMRAP — превзойди заданный минимум",
    "weight": "Вес",
    "extra": "Доп. (+/−)",
    "unit": "Единицы",
    "rpe": "RPE",
    "addSet": "Добавить подход",
    "removeSet": "Удалить подход",
    "notes": "Заметки (необязательно)",
    "setNoteToggle": "Добавить заметку к этому подходу",
    "setNotePlaceholder": "Что было особенного в этом подходе",
    "draftRecoveryHeadline": "У вас незаконченная тренировка от {{when}}.",
    "draftRecoveryContinue": "Продолжить",
    "draftRecoveryDiscard": "Отменить",
    "maxBumpAvailable": "{{exercise}}: новый MAX {{value}}",
    "maxBumpConfirm": "↑ Подтвердить",
    "maxBumpSaving": "Сохранение…",
    "prefillFromDate": "Заполнить из тренировки {{date}}?",
    "prefillAccept": "Применить",
    "prefillDismiss": "Пропустить",
    "savePromptTitle": "Проверьте перед сохранением",
    "savePromptContinue": "Вернуться к тренировке",
    "savePromptAnyway": "Всё равно сохранить",
    "unmarkedPromptBody": "{{count}} подходов с данными, но без отметки.",
    "unmarkedPromptFail": "Отметить как неудачные и сохранить",
    "unmarkedPromptComplete": "Отметить как выполненные и сохранить",
    "outlierPromptBody": "{{count}} записей выглядят необычно:",
    "outlierItem": "{{exercise}}: {{weight}} (исторический максимум {{expected}})",
    "outlierE1rmItem": "{{exercise}}: расчётный 1ПМ {{e1rm}} (исторический максимум {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} примерно вдвое больше твоего обычного {{expected}} — ты ввёл вес ОДНОЙ гантели или общий вес двух?",
    "outlierRepsItem": "{{exercise}}: {{reps}} повторений — слишком много",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} повторений без веса",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Тренировка сохранена.",
    "savedEdit": "Тренировка обновлена.",
    "savedEditOldRemains": "Тренировка обновлена, но прежняя версия осталась в истории. Удалите её вручную.",
    "deleted": "Тренировка удалена.",
    "cancel": "Отмена",
    "errNoSets": "Добавьте хотя бы один корректный подход.",
    "creatingTitle": "Новая тренировка",
    "editingTitle": "Редактировать тренировку",
    "exerciseN": "Упражнение {{n}}",
    "addExercise": "Добавить ещё одно упражнение",
    "removeExercise": "Убрать упражнение",
    "removeExerciseConfirm": "Убрать {{name}} из тренировки? Уже записанные подходы будут потеряны.",
    "groupAlignTitle": "Разное число подходов",
    "groupAlignBody": "У участников группы от {{shortest}} до {{longest}} подходов. Выровнять, чтобы раунды совпадали?",
    "groupAlignPad": "+ Дополнить до {{n}}",
    "groupAlignTrim": "− Сократить до {{n}}",
    "groupAlignTrimWarning": "Сокращение удалит уже записанные подходы, и вернуть их будет нельзя.",
    "groupAlignTrimHint": "Удаляет лишние подходы у каждого участника группы. Отменить нельзя.",
    "groupAlignKeep": "Оставить как есть",
    "splitGroup": "Разъединить",
    "splitGroupTitle": "Разъединить группу?",
    "splitGroupBody": "Упражнения сохранят свои подходы и останутся в тренировке, просто перестанут быть связанными. Вы можете снова объединить их в любой момент.",
    "splitGroupConfirm": "Разъединить",
    "removeRoundConfirmTitle": "Удалить этот раунд?",
    "removeRoundConfirmBody": "Раунд {{n}} упражнений {{names}} будет удалён вместе.",
    "bilateral": "Билатерально",
    "unilateral": "Унилатерально",
    "edit": "Изменить",
    "repeat": "Повторить",
    "delete": "Удалить",
    "deleting": "Удаление…",
    "deleteConfirm": "Удалить эту тренировку?",
    "distance": "м",
    "duration": "с",
    "cardioDuration": "Длительность",
    "cardioDistance": "Дистанция",
    "cardioWeight": "Вес",
    "cardioHr": "ЧСС ср.",
    "cardioCalories": "Калории",
    "cardioOptionalsShow": "Другие поля",
    "cardioOptionalsHide": "Другие поля",
    "dateEditor": "Дата и длительность",
    "dateLabel": "Дата",
    "startTimeLabel": "Начало",
    "endTimeLabel": "Конец",
    "durationLabel": "Длительность",
    "side": "Сторона",
    "sideLeft": "Левая",
    "sideRight": "Правая",
    "sideBoth": "Обе",
    "showRpe": "Учитывать RPE",
    "showDuration": "Учитывать время",
    "rir": "RIR {{n}}",
    "swap": "Заменить",
    "swapHint": "Скамья занята? Выберите похожее упражнение.",
    "descriptionToggle": "Показать / скрыть описание",
    "failShort": "F",
    "failToggle": "Отметить подход как несдавшийся",
    "failHint": "Последнее повторение не закрыто. Учитывается в объёме, но не идёт в PR.",
    "startRest": "Запустить таймер отдыха",
    "restStartDefault": "Старт отдыха ({{n}}с)",
    "restStartCustom": "Старт отдыха ({{n}}с, по умолчанию)",
    "setComplete": "Отметить подход выполненным",
    "setCompleteHint": "Зафиксировать подход и запустить отдых {{n}} с.",
    "setCompleteHintCustom": "Зафиксировать подход и запустить отдых {{n}} с (по умолчанию).",
    "setUndo": "Отменить отметку",
    "setUndoHint": "Нажмите снова, чтобы отменить и сбросить таймер.",
    "restLeft": "Отдых",
    "restDone": "Время вышло",
    "restStop": "Стоп",
    "restPause": "Пауза",
    "restResume": "Продолжить",
    "restSound": "Сигнал в конце отдыха",
    "instructions": "Указания тренера (по желанию)",
    "instructionsPlaceholder": "Фокус сессии, что пропустить при нехватке времени, замысел.",
    "lastTime": "Прошл.",
    "lastToday": "сегодня",
    "lastDaysAgo": "{{n}} дн назад",
    "dropsetShort": "Drop",
    "dropsetToggle": "Добавить цепочку дропсета",
    "dropsetHint": "Цепочка дополнительных повторений без отдыха.",
    "dropsetTitle": "Дропсет",
    "dropsetVariant": "Вариант",
    "dropsetClassical": "Классический (вес снижается)",
    "dropsetMyorep": "Мио-реп (тот же вес)",
    "dropsetHintClassical": "Снизьте вес на 10–30 % и продолжайте до отказа. Без паузы.",
    "dropsetHintMyorep": "Тот же вес, меньше повторений, 10–20 с дыхания, повторить.",
    "dropsetSameLoad": "= тот же",
    "dropsetAddStep": "Добавить дроп",
    "dropsetRemove": "Убрать",
    "dropsetRemoveConfirm": "У тебя {{n}} drop-шагов. Преобразовать обратно в обычный подход и удалить их?",
    "dropsetRemoveStep": "Убрать дроп",
    "groupLabel": "Группа",
    "groupNone": "(нет)",
    "groupCreate": "Создать",
    "groupNewSuperset": "Новый суперсет",
    "groupNewCircuit": "Новый циркуит",
    "groupJoinExisting": "Присоединиться к существующей",
    "groupLeave": "Разгруппировать",
    "groupSharedHint": "Общая. Откройте другое упражнение и выберите ту же группу из списка, чтобы связать их.",
    "supersetN": "Суперсет {{n}}",
    "circuitN": "Циркуит {{n}}",
    "supersetDerived": "Суперсет (авто)",
    "supersetDerivedTitle": "Определён по чередованию подходов в этой сессии",
    "playActiveTitle": "Активное упражнение — последний завершённый подход",
    "errGroupKindMixed": "Одна группа не может смешивать суперсет и циркуит. Выберите один тип.",
    "exerciseNew": "Новое упражнение",
    "cardMenu": "Опции упражнения",
    "menuReplace": "Заменить упражнение",
    "menuGroup": "Группа / суперсет",
    "menuMoveUp": "Переместить вверх",
    "menuMoveDown": "Переместить вниз",
    "menuShowNotes": "Показать заметки",
    "menuHideNotes": "Скрыть заметки",
    "menuShowDescription": "Показать описание",
    "menuHideDescription": "Скрыть описание",
    "tipAlternatives": "Альтернативные упражнения",
    "tipCoachNote": "Заметка тренера",
    "perImplementHint": "Используешь два или по одной стороне? Укажи вес одного. Приложение посчитает оба (×2).",
    "tipProgramNote": "В этой программе",
    "tipNoAlternatives": "В каталоге нет похожих упражнений",
    "tipClose": "Закрыть",
    "painBanner": {
      "red": "Нагружает болезненную мышцу",
      "yellow": "Внимание: нагружает помеченную мышцу",
      "green": "Без риска боли"
    },
    "setCycleHint": "Тап: готово · ещё: провал · ещё: отмена",
    "setStatePending": "Подход открыт",
    "setStateDone": "Подход закрыт",
    "setStatePr": "Подход закрыт, личный рекорд",
    "setStateFailed": "Подход помечен как неудачный",
    "prShort": "🏆",
    "addDrop": "+ дроп",
    "groupBannerSuperset": "СУПЕРСЕТ",
    "groupBannerCircuit": "ЦИРКУИТ",
    "groupAutoTag": "АВТО",
    "groupAutoConfirm": "Зафиксировать",
    "groupAutoConfirmAria": "Зафиксировать группу: остановить детектор и оставить упражнения связанными",
    "groupAutoDismiss": "Распустить",
    "groupAutoDismissAria": "Игнорировать определение: упражнения снова становятся отдельными",
    "groupAddSetAll": "Добавить подход всем",
    "nameLabel": "Название (необязательно)",
    "namePlaceholder": "Напр. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "регулировка длительности",
    "rirLabel": "RIR",
    "showRir": "Учитывать RIR",
    "maxDownA11y": "MAX возможно снизился",
    "animationOf": "Анимация: {{name}}",
    "animationZoomHint": "Откроет анимацию на весь экран",
    "closeAnimation": "Закрыть анимацию",
    "showAnimation": "Показать анимацию",
    "showBodyMap": "Показать задействованные мышцы",
    "pageOf": "{{current}} из {{total}}",
    "pagerDot": "{{target}}, {{current}} из {{total}}"
  },
  "program": {
    "title": "Программы",
    "help": "Многонедельные тренировочные циклы. Фаза 5.1 даёт скелет: имя, недели, тренировок в неделю. Конструктор слотов и прогрессии — в следующей фазе.",
    "new": "Новая программа",
    "newTitle": "Новая программа",
    "name": "Имя",
    "namePlaceholder": "напр. Powerbuilding 6 недель",
    "cycleWeeks": "Недели цикла",
    "sessionsPerWeek": "Тренировок в неделю",
    "description": "Описание",
    "descriptionPlaceholder": "Зачем цикл, для кого, заметки для атлетов.",
    "create": "Создать",
    "creating": "Новая программа: {{name}}",
    "cancel": "Отмена",
    "delete": "Удалить",
    "deleteConfirm": "Подтвердить?",
    "deleteConfirmYes": "Да, удалить",
    "loading": "Загрузка программ…",
    "empty": "Пока нет программ. Создайте одну для планирования многонедельного цикла.",
    "statusDraft": "Черновик",
    "statusActive": "Активна",
    "statusArchived": "В архиве",
    "cycleWeeksLabel": "Цикл из {{n}} нед.",
    "sessionsPerWeekLabel": "{{n}}× / нед.",
    "slotCount": "{{n}} слот(ов)",
    "skeletonHint": "Только скелет. Слоты заполнятся в следующей фазе.",
    "sessionDefaultName": "Тренировка {{n}}",
    "edit": "Редактировать",
    "editing": "Редактирование: {{name}}",
    "backToList": "Назад к программам",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "errSave": "Не удалось сохранить программу.",
    "metaLegend": "Программа",
    "status": "Статус",
    "metaCyclesLive": "Структурные изменения (дни, недели) применяются сразу",
    "ordinalSession": "{{n}}-я тренировка",
    "sessionName": "Название тренировки",
    "slotN": "Слот {{n}}",
    "addSlot": "Добавить слот",
    "removeSlot": "Удалить",
    "moveUp": "Переместить вверх",
    "moveDown": "Переместить вниз",
    "exercise": "Упражнение",
    "exercisePick": "Выберите упражнение",
    "setsLegend": "Подходы",
    "addSet": "Добавить подход",
    "removeSet": "Удалить подход",
    "reps": "Повт.",
    "setNotesPlaceholder": "Заметка к подходу (необязательно)",
    "set": "Подход",
    "intensityKind": "Интенсивность",
    "intensityNone": "Свободно",
    "intensityPercent": "% от MAX",
    "intensityAbs": "кг (абсолютно)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Процент",
    "intensity_absolute": "Вес (кг)",
    "intensity_rpe": "RPE",
    "weekShort": "Н{{n}}",
    "previewShow": "Превью",
    "previewHide": "Скрыть превью",
    "previewMuscles": "Задействованные мышцы",
    "previewSets": "{{n}} подходов",
    "previewEmptySession": "В этой тренировке нет слотов.",
    "previewEmptyProgram": "Пока нет слотов. Откройте «Редактировать», чтобы добавить.",
    "start": "Начать тренировку",
    "startCancel": "Отмена",
    "startGo": "Начать",
    "starting": "Запуск…",
    "startWeek": "Неделя",
    "startSession": "Тренировка",
    "progressNext": "Следующая: Н{{w}} · Тренировка {{s}}",
    "instructions": "Указания",
    "instructionsPlaceholder": "Темп, длина паузы, технический фокус, целевой RPE.",
    "amrapLastSet": "AMRAP в последнем подходе",
    "maxAttempt": "Попытка 1MAX",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Применяется на протяжении {{n}} недель цикла.",
    "catalogLoading": "Загрузка каталога упражнений…",
    "builderComingSoon": "Конструктор слотов и прогрессии появится в Фазе 5.2. Пока это создаёт пустую оболочку, которую можно удалить или заполнить позже.",
    "errCycleWeeks": "Недели должны быть от 1 до 12.",
    "errSessionsPerWeek": "Тренировок в неделю должно быть от 1 до 7.",
    "errName": "Имя программы обязательно.",
    "errEmptyDay": "В каждом тренировочном дне должно быть хотя бы одно упражнение.",
    "errSchema": "Некорректные данные программы.",
    "errCreate": "Не удалось создать программу.",
    "errCode": {
      "sessionNameEmpty": "У каждого тренировочного дня должно быть название.",
      "slotNoExercise": "Выберите упражнение для каждого слота.",
      "slotNoSets": "В каждом упражнении должен быть хотя бы один подход.",
      "slotAllWeeksInactive": "Упражнение отключено во всех неделях. Включите неделю или удалите его.",
      "rowWidthMismatch": "Строка подходов не совпадает с числом недель. Откройте упражнение заново и попробуйте ещё раз.",
      "invalidReps": "Проверьте повторения: используйте число, например 8, или 8+ для AMRAP.",
      "groupKindMixed": "В суперсете смешаны типы подходов. Задайте его упражнениям один тип.",
      "schemaInvalid": "Некорректные данные программы.",
      "noSession": "Нет тренировки для сохранения.",
      "planNameEmpty": "Имя плана обязательно.",
      "planNoExercises": "Добавьте в план хотя бы одно упражнение.",
      "invalidIntensityValue": "Проверьте значение интенсивности: должно быть числом.",
      "weightOutOfRange": "Этот вес вне диапазона.",
      "pctOutOfRange": "Процент должен быть от 0 до 200.",
      "rpeOutOfRange": "RPE должен быть от 1 до 10.",
      "rirOutOfRange": "RIR должен быть от 0 до 10.",
      "unknownIntensityKind": "Неизвестный тип интенсивности.",
      "invalidSeconds": "Проверьте секунды: подходу на время нужна длительность, целыми секундами до 3600."
    },
    "cardMenu": "Меню слота",
    "menuGroup": "Группа",
    "groupNone": "Без группы",
    "groupJoinExisting": "Добавить в группу",
    "groupCreate": "Создать",
    "groupNewSuperset": "Новый суперсет",
    "groupNewCircuit": "Новый круг",
    "groupSupersetN": "Суперсет {{letter}}",
    "groupCircuitN": "Круг {{letter}}",
    "assignTo": "Назначить спортсменам",
    "assignToHelp": "Программа добавляется в библиотеку каждого спортсмена. Требуется активная связь с тренером.",
    "assignSelf": "Ты (автор)",
    "addAssignee": "Добавить",
    "removeAssignee": "Убрать",
    "assigneePlaceholder": "sportsmen@primer.com",
    "follow": "Следовать",
    "unfollow": "Не следовать",
    "followHint": "Следовать этой программе (появится в разделе Текущие)",
    "publish": "Опубликовать",
    "unpublish": "Вернуть в черновик",
    "publishAndFollow": "Опубликовать и следовать",
    "publishHint": "Сделать программу доступной для отслеживания",
    "chipDraft": "Черновик",
    "chipPublished": "Опубликован",
    "chipFollowed": "Слежу",
    "kindShortAbsolute": "КГ",
    "kindShortAbsoluteLb": "ФУНТ",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "ИСТ",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Язык",
    "languageA11y": "Язык написания",
    "languageSwitchQuestion": "На каком языке вы пишете?",
    "languageDeclareQuestion": "На каком языке написана эта программа?",
    "languageFootnote": "Переводы необязательны: программа на одном языке полна.",
    "languageDeclareFootnote": "Ничего не переводится: это только указывает язык.",
    "languageAuto": "Машинный перевод",
    "languageNotYetWritten": "Версии на {{lang}} пока нет. Текст на {{original}} остаётся на месте.",
    "setBound": "Предел",
    "boundReps": "Повт.",
    "boundTime": "Время",
    "boundOpen": "Свободно",
    "workSeconds": "Работа (с)",
    "restSeconds": "Отдых (с)",
    "restSecondsPlaceholder": "авто",
    "prescribeTime": "Время",
    "prescribeTimeA11y": "Задать работу и отдых в секундах",
    "seconds": "Секунды",
    "amrapNotWithTime": "Подход на {{secs}} с не может быть AMRAP: план не может спросить, сколько ты успеешь. Убери + или время.",
    "workSecondsRequired": "Сколько секунд?"
  },
  "me": {
    "targets": {
      "title": "Цели",
      "historyByCoach": "Ваш тренер",
      "errNotFound": "Не удалось найти ваши цели. Вернитесь назад и повторите."
    }
  },
  "coach": {
    "title": "Тренер и спортсмены",
    "subtitle": "Спортсмены, которых вы тренируете, и тренеры, которые тренируют вас. Приглашение требует согласия обеих сторон, прежде чем назначения смогут передаваться.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Пригласить спортсмена по email",
    "invitePlaceholder": "sportsmen@primer.com",
    "inviteNotePlaceholder": "Заметка (необязательно)",
    "inviteSend": "Отправить приглашение",
    "inviteSending": "Отправка…",
    "inviteSent": "Приглашение отправлено. Спортсмен увидит его при следующем входе.",
    "athletesHeading": "Мои спортсмены",
    "coachesHeading": "Мои тренеры",
    "athletesEmpty": "Спортсменов пока нет. Пригласите выше.",
    "pendingInLabel": "Ждёт вашего ответа",
    "pendingOutLabel": "Ждём их ответа",
    "activeLabel": "Активные",
    "accept": "Принять",
    "decline": "Отклонить",
    "cancel": "Отменить приглашение",
    "revoke": "Отозвать",
    "leave": "Покинуть тренера",
    "busy": "Выполняется…",
    "loading": "Загрузка…",
    "loadFailed": "Не удалось загрузить. Обновите страницу.",
    "errCode": {
      "invalid_email": "Неверный формат email.",
      "email_not_found": "Нет подтверждённого аккаунта с таким email.",
      "peer_required": "Укажите email или sub.",
      "edge_exists": "Связь с этим партнёром уже существует.",
      "userpool_not_configured": "Сервер неправильно настроен: user pool недоступен.",
      "io_error": "Ошибка сети или сервера. Попробуйте снова.",
      "not_pending": "Это приглашение больше не ожидает ответа.",
      "wrong_party": "Только другая сторона может принять это приглашение."
    },
    "dashboard": {
      "title": "Обзор команды",
      "unnamedAthlete": "Спортсмен",
      "empty": "Пока нет спортсменов",
      "emptySub": "Пригласите спортсменов в разделе «Тренер и спортсмены», чтобы увидеть их здесь.",
      "loading": "Загрузка вашей команды…",
      "loadFailed": "Не удалось загрузить команду. Обновите, чтобы повторить.",
      "noProgram": "Нет программы",
      "kpiAssigned": "Спортсмены",
      "kpiActive": "Активны на этой неделе",
      "kpiAttention": "Требуют внимания",
      "kpiAdherence": "Средн. соблюдение",
      "kpiSessions": "Тренировки на этой неделе",
      "adherence": "соблюдение",
      "lastToday": "сегодня",
      "lastNever": "не тренировался",
      "lastDaysAgo": "{{count}} дн. назад",
      "flagStale": "Не тренируется",
      "flagUnderTarget": "Ниже цели",
      "flagOnTrack": "В графике",
      "flagNoProgram": "Нет программы"
    },
    "detail": {
      "back": "Назад к команде",
      "maxesTitle": "Текущие MAX",
      "maxesEmpty": "MAX ещё не записаны",
      "rhythmSummary": "в среднем {{avg}}/нед за {{weeks}} нед · прошлая неделя: {{last}}",
      "effortTitle": "Покрытие усилия",
      "effortLabel": "подходы с записанным RIR",
      "effortSummary": "{{tagged}} из {{counted}} засчитанных подходов, включая разминочные",
      "effortEra": "Данные об усилии начинаются {{date}} · {{count}} более ранних подходов не учтены",
      "effortNone": "Ни в одном подходе пока нет значения усилия, поэтому числам по тяжёлым подходам и целям не на что опереться.",
      "effortError": "Не удалось загрузить данные об усилии.",
      "maxesSeeAll": "Показать все (+{{count}})",
      "maxesShowFewer": "Показать меньше"
    },
    "targets": {
      "eyebrow": "Недельные цели",
      "edit": "Изменить цели",
      "degradedHint": "У этого атлета пока нет недельных целей. Задайте их, чтобы оценивать его неделю относительно цели.",
      "noGrant": "Только чтение — атлет не разрешил вам изменять цели.",
      "historyTitle": "История изменений",
      "historyEmpty": "Изменений пока нет.",
      "historyByYou": "Вы",
      "historyTruncated": "Показаны последние 1000 изменений.",
      "histGeneric": "Цели обновлены",
      "histSet": "задано: {{value}}",
      "histRemoved": "удалено",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Загрузка…",
      "errLoad": "Не удалось загрузить эти цели. Вернитесь назад и повторите.",
      "errStale": "Эти цели изменились, пока вы редактировали. Перезагрузите и примените снова.",
      "errNoGrant": "Атлет не разрешил вам изменять цели.",
      "errNotCoach": "Вы не тренер этого атлета.",
      "errMultiAssignee": "Эта программа используется более чем одним атлетом.",
      "errRetry": "Ещё загружается — повторите через мгновение.",
      "errNotFound": "Этой программы больше нет.",
      "errOffline": "Не удалось сохранить. Проверьте подключение и повторите."
    }
  },
  "plans": {
    "title": "Планы",
    "help": "Составьте тренировку для себя. Цели могут быть в абсолютных кг или в процентах от MAX, переводятся в кг при запуске плана.",
    "loading": "Загрузка планов…",
    "empty": "Планов пока нет. Добавьте один, чтобы подготовить тренировку заранее.",
    "todayPill": "Сегодня",
    "add": "Добавить план",
    "edit": "Изменить",
    "start": "Начать",
    "cancel": "Отмена",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "План сохранён.",
    "savedEdit": "План обновлён.",
    "deleted": "План удалён.",
    "delete": "Удалить",
    "deleting": "Удаление…",
    "deleteConfirm": "Удалить этот план?",
    "creatingTitle": "Новый план",
    "editingTitle": "Изменить план",
    "name": "Название",
    "namePlaceholder": "напр. День приседа",
    "scheduledFor": "Запланировано на (необязательно)",
    "pickDate": "Выберите дату",
    "pickDateHint": "Открывает выбор даты",
    "clearDate": "Очистить дату",
    "noDate": "Не задана",
    "notes": "Заметки (необязательно)",
    "rpeEnabledLabel": "Показывать колонку RPE в Логгере",
    "rpeEnabledHelp": "Когда включено, сессии, запущенные из этого плана, открываются с видимой колонкой RPE. Атлет всё равно может переключать её для каждой сессии.",
    "exercise": "Упражнение",
    "exercisePlaceholder": "Выберите упражнение",
    "exerciseN": "Упражнение {{n}}",
    "removeExercise": "Убрать упражнение",
    "addExercise": "Добавить ещё одно упражнение",
    "setsLegend": "Подходы",
    "targetReps": "Повт.",
    "targetWeight": "Вес",
    "targetKind": "Ед.",
    "targetRpe": "RPE",
    "noMaxYet": "нет MAX",
    "addSet": "Добавить подход",
    "removeSet": "Убрать подход",
    "statusDraft": "Черновик",
    "statusScheduled": "Запланирован",
    "statusCompleted": "Выполнен",
    "statusSkipped": "Пропущен",
    "errNotSignedIn": "Нужно войти в аккаунт.",
    "errNameRequired": "Назовите план.",
    "errPickExercise": "Выберите упражнение из каталога.",
    "errNoSets": "Добавьте хотя бы один корректный подход.",
    "errGroupKindMixed": "Два упражнения используют один group id, но помечены как суперсет и круг. Выберите одно и сохраните снова.",
    "assignTo": "Также назначить",
    "assignToHelp": "Введите email и нажмите Enter. У адреса уже должен быть аккаунт, иначе план отклоняется.",
    "addAssignee": "Добавить",
    "removeAssignee": "Удалить",
    "assigneePlaceholder": "имя@пример.ru",
    "exerciseNew": "Выберите упражнение",
    "setIndex": "Подход {{n}}",
    "cardMenu": "Меню карточки",
    "menuGroup": "Группа",
    "menuMoveUp": "Выше",
    "menuMoveDown": "Ниже",
    "groupNone": "Без группы",
    "groupJoinExisting": "Добавить в группу",
    "groupCreate": "Создать",
    "groupNewSuperset": "Новый суперсет",
    "groupNewCircuit": "Новый круг",
    "groupSupersetN": "Суперсет {{letter}}",
    "groupCircuitN": "Круг {{letter}}",
    "details": "Подробности",
    "exercisesLabel": "Упражнения",
    "editorEmpty": "Пока нет упражнений. Добавьте одно, чтобы начать составлять план.",
    "selectExercisePrompt": "Выберите упражнение, чтобы изменить его подходы.",
    "addExerciseCta": "Добавить упражнение",
    "removeExerciseConfirm": "Удалить это упражнение?",
    "removeExerciseHint": "Нажмите один раз для подтверждения, затем нажмите ещё раз, чтобы удалить.",
    "collapseExercise": "Свернуть упражнение",
    "supersetTag": "СУПЕРСЕТ",
    "exerciseNoteLabel": "Заметка к упражнению (необязательно)"
  },
  "templates": {
    "show": "Открыть стартовые шаблоны",
    "hide": "Скрыть шаблоны",
    "help": "Готовые планы и программы. Склонируйте один в свой аккаунт — копия ваша, редактируйте или удаляйте, не трогая исходный шаблон.",
    "loading": "Загрузка шаблонов…",
    "empty": "Шаблоны пока недоступны.",
    "errLoad": "Не удалось загрузить шаблоны.",
    "clone": "Клонировать к себе",
    "cloning": "Клонирование…",
    "cloned": "«{{name}}» склонирован.",
    "alreadyCloned": "Уже клонирован",
    "difficultyBeginner": "Новичок",
    "difficultyIntermediate": "Средний",
    "difficultyAdvanced": "Продвинутый",
    "planMeta": "{{n}} упражн.",
    "programMeta": "Цикл {{weeks}} нед. · {{sessions}}× / нед."
  },
  "maxes": {
    "title": "Максимумы",
    "countLabel_one": "{{count}} задан",
    "countLabel_few": "{{count}} заданы",
    "countLabel_many": "{{count}} задано",
    "countLabel_other": "{{count}} задано",
    "help": "MAX - это то, что вы можете поднять сегодня, заданное вами. Программы используют его как базу для процентов. Расчётный 1ПМ в разделе «Прогресс» - только для справки.",
    "loading": "Загрузка максимумов…",
    "empty": "Максимумов пока нет. Добавьте один, чтобы запустить программирование на процентах.",
    "add": "Добавить максимум",
    "edit": "Изменить",
    "delete": "Удалить",
    "deleteAction": "Удалить MAX",
    "deleting": "Удаление…",
    "deleted": "MAX удалён.",
    "deleteConfirm": "Удалить MAX для {{name}}? История также удаляется. Следующий seed из истории может заполнить его заново из тренировок.",
    "exercise": "Упражнение",
    "exercisePlaceholder": "Выберите упражнение",
    "value": "Значение",
    "source": "Источник",
    "sourceManual": "Задано вручную",
    "sourceTested": "Протестировано в зале",
    "sourceDerived": "Получено из записанного подхода",
    "sourceCalculated": "Оценено по истории",
    "sourceImported": "Импортировано",
    "notes": "Заметки (необязательно)",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Максимум сохранён.",
    "cancel": "Отмена",
    "errPickExercise": "Выберите упражнение.",
    "errInvalidValue": "Введите значение от 0 до 2000.",
    "seed": {
      "start": "Предложить из истории",
      "loading": "Чтение истории…",
      "reviewIntro": "{{count}} упражнений имеют достоверный топ-сет в истории. Выберите, какие использовать как MAX. Упражнения с уже заданным MAX пропускаются.",
      "selectAll": "Выбрать все",
      "selectNone": "Снять выделение",
      "fromSet": "по {{weight}} × {{reps}}",
      "cancel": "Отмена",
      "apply": "Записать {{count}} MAX",
      "applying": "Сохранение: {{done}} / {{total}}",
      "applied": "Записано {{count}} MAX из истории.",
      "noneApplicable": "Нечего задавать. Либо у всех упражнений уже есть MAX, либо весовой истории не найдено.",
      "close": "Закрыть"
    }
  },
  "progress": {
    "coverageTitle": "Охват мышц",
    "coverageSubtitle": "к недельной цели",
    "coverageTopTrained": "Самые нагруженные мышцы на этой неделе.",
    "coverageLead": "Ниже недельной цели: {{count}}",
    "coverageAllGood": "Все целевые мышцы в норме на этой неделе.",
    "coverageAvg": "сред. {{n}}/нед",
    "coverageSeeAll": "Все мышцы (+{{count}})",
    "coverageShowFewer": "Свернуть",
    "detailsTitle": "Подробнее",
    "detailsSubtitle": "Расширенная аналитика тренировок",
    "period": {
      "days": "{{days}} дн",
      "painDays": "7 / {{days}} дн",
      "selectorLabel": "Окно анализа"
    },
    "title": "Прогресс",
    "show": "Показать",
    "hide": "Скрыть",
    "help": "MAX вы задаёте сами; расчётный 1ПМ по Эпли используется как ориентир. Объём - сумма произведений веса на повторения за тренировку.",
    "e1rm": "Расчётный 1ПМ",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "расчётный 1ПМ пунктиром",
    "volume": "Объём",
    "sessions": "{{n}} тренировок",
    "prFound": "Личный рекорд: {{weight}}.",
    "prUpdate": "Установить MAX в {{weight}}",
    "prUpdating": "Обновление…",
    "viewByExercise": "По упражнению",
    "viewByTag": "По тегу",
    "noTags": "Пока нет тренировок с тегами. Добавьте теги к упражнениям в каталоге, чтобы увидеть здесь агрегированный объём.",
    "totalVolume": "Всего {{weight}}",
    "recordsScope": "Рекорды",
    "recordsAllTime": "За всё время",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Фильтр упражнений",
    "filterCount": "{{visible}} из {{total}}",
    "filterNoMatch": "Под фильтр ничего не подходит.",
    "coverageNoData": "Пока нечего оценивать: запишите тренировку или задайте недельную цель."
  },
  "cohort": {
    "compare": "Сравнить с группой (анонимно)",
    "hide": "Скрыть сравнение",
    "loading": "Загрузка данных группы…",
    "empty": "Пока недостаточно данных для сравнения. Порог - десять человек в одной возрастной группе.",
    "contributors": "На основе {{n}} анонимных вкладов с указанной возрастной группой.",
    "yourGroup": "ваша группа"
  },
  "catalog": {
    "title": "Каталог упражнений",
    "loading": "Загрузка…",
    "empty": "Упражнений пока нет.",
    "seedStarter": "Загрузить базовый набор",
    "seeding": "Загрузка…",
    "importTaxonomy": "Импортировать полную библиотеку упражнений",
    "importTaxonomyUpsert": "Обновить из библиотеки",
    "importing": "Импорт…",
    "importDone": "Импорт завершён. Создано {{created}}, обновлено {{upserted}}, пропущено {{skipped}}, ошибок {{failed}}.",
    "add": "Добавить упражнение",
    "edit": "Изменить",
    "cancel": "Отмена",
    "save": "Сохранить",
    "create": "Создать",
    "saving": "Сохранение…",
    "name": "Название",
    "namePlaceholder": "напр. Приседания со штангой",
    "primaryMuscle": "Основная мышца (необязательно)",
    "primaryMusclePlaceholder": "напр. квадрицепсы",
    "primaryLabel": "Основные мышцы (минимум одна)",
    "secondaryLabel": "Дополнительные мышцы (необязательно)",
    "addMuscle": "+ Добавить мышцу",
    "removeMuscle": "Убрать мышцу",
    "errPrimaryRequired": "Выберите хотя бы одну основную мышцу.",
    "isBodyweight": "Упражнение с собственным весом",
    "isBodyweightHelp": "Подходы фиксируют повторения и опциональный дополнительный вес, а не вес штанги.",
    "hasP1RM": "Программируется в процентах от MAX",
    "hasP1RMHelp": "Позволяет планам задавать цель как долю MAX для этого упражнения.",
    "defaultRest": "Отдых по умолчанию (с)",
    "defaultRestPlaceholder": "напр. 180",
    "defaultRestHelp": "Сколько секунд отсчитывает таймер отдыха по умолчанию. Пусто — значение приложения (90 с).",
    "defaultBar": "Вес специального грифа (кг)",
    "defaultBarPlaceholder": "напр. 7",
    "defaultBarHelp": "Curl-гриф 7, трэп-бар 11, landmine ~10. Калькулятор блинов открывается с этим значением для подходов этого упражнения. Оставьте пустым для значения по умолчанию из списка.",
    "pinnedNoteLabel": "Подсказка настройки (необязательно)",
    "pinnedNotePlaceholder": "напр. Высота рамы 4, страховочные упоры 6, пауза 1с",
    "pinnedNoteHelp": "Показывается баннером под названием упражнения в Логгере. Переопределения на уровне плана или слота программы имеют приоритет, когда заданы.",
    "noMuscle": "-",
    "bw": "BW",
    "p1rm": "1RM%",
    "errSlug": "Используйте латинские буквы в названии, чтобы система могла построить стабильный идентификатор.",
    "errSlugExists": "Упражнение с таким названием уже существует.",
    "searchPlaceholder": "Поиск упражнений…",
    "region": "Зона",
    "regionAll": "Все зоны",
    "region_lower": "Низ",
    "region_posterior": "Задняя цепь",
    "region_chest": "Грудь",
    "region_back": "Спина",
    "region_shoulders": "Плечи",
    "region_arms": "Руки",
    "region_core": "Кор",
    "region_cardio": "Кардио",
    "region_other": "Другое",
    "pattern": "Паттерн",
    "patternAll": "Все паттерны",
    "pattern_squat": "Присед",
    "pattern_hinge": "Тазобедренный сгиб",
    "pattern_horizontal-push": "Горизонтальный жим",
    "pattern_vertical-push": "Вертикальный жим",
    "pattern_horizontal-pull": "Горизонтальная тяга",
    "pattern_vertical-pull": "Вертикальная тяга",
    "pattern_lunge": "Выпад",
    "pattern_carry": "Перенос",
    "pattern_core": "Кор",
    "pattern_isolation": "Изоляция",
    "pattern_cardio": "Кардио",
    "pattern_other": "Другое",
    "equipment": "Снаряд",
    "equipmentAll": "Все снаряды",
    "equipment_barbell": "Штанга",
    "equipment_dumbbell": "Гантели",
    "equipment_kettlebell": "Гиря",
    "equipment_cable": "Блочный тренажёр",
    "equipment_machine": "Тренажёр",
    "equipment_bodyweight": "Своё тело",
    "equipment_band": "Резина",
    "equipment_other": "Другое",
    "clearFilters": "Сбросить фильтры",
    "noResults": "Нет упражнений по этим фильтрам.",
    "tags": "Теги",
    "tagsHelp": "Свободные метки для фильтров и отчётов. Введите slug и нажмите Enter, либо нажмите «Предложить», чтобы взять метки из структурных полей.",
    "tagsPlaceholder": "напр. compound, warmup, for-sandrine",
    "addTag": "Добавить",
    "removeTag": "Убрать тег",
    "suggestTags": "Предложить",
    "description": "Описание",
    "descriptionHelp": "Краткая заметка в каталоге и подсказка в логгере. Остальные языки заполняются автоматически.",
    "descriptionPlaceholder": "Установка, ключевой акцент, типичная ошибка…",
    "descriptionResetDefault": "Сбросить к встроенному значению",
    "locale_en": "EN",
    "locale_it": "IT",
    "locale_fr": "FR",
    "locale_de": "DE",
    "locale_ru": "RU",
    "equipment_treadmill": "Беговая дорожка",
    "equipment_exercise-bike": "Велотренажёр",
    "equipment_elliptical": "Эллиптический тренажёр",
    "equipment_rower": "Гребной тренажёр",
    "equipment_stair-climber": "Степпер",
    "equipment_jump-rope": "Скакалка",
    "equipment_battle-ropes": "Боевые канаты",
    "equipment_sled": "Сани",
    "deletedExercise": "Удалённое упражнение"
  },
  "swap": {
    "title": "Заменить упражнение",
    "currentLabel": "Текущее",
    "searchPlaceholder": "Поиск в каталоге…",
    "showAll": "Показать все упражнения",
    "noMatches": "Нет упражнений по запросу.",
    "noSuggestions": "Похожих по тегам не найдено. Включите «Показать все», чтобы открыть весь каталог.",
    "close": "Закрыть",
    "reasonTags": "Общих тегов: {{count}}",
    "reasonPrimary": "Общих мышц: {{count}}",
    "reasonDifferentEquipment": "Другое оборудование",
    "suggestedSection": "Рекомендуемые",
    "allSection": "Все упражнения",
    "whichMachine": "Какой тренажёр?",
    "defaultMachine": "Тренажёр по умолчанию",
    "machineLabel": "Тренажёр {{letter}}",
    "setMachine": "Выбрать тренажёр",
    "machineChoices": "Известных тренажёров: {{count}}",
    "newMachine": "Новый тренажёр",
    "bandSession": "Тренировка",
    "bandCurrentExercise": "Это упражнение",
    "bandOtherExercises": "Перейти к другому упражнению",
    "equipmentKey": "Оборудование",
    "currentConsequence": "Уже записанные подходы останутся: изменится только оборудование, на котором они отмечены.",
    "unavailableTitle": "Здесь этого нет?",
    "unavailableBody": "Отметьте оборудование для «{{exercise}}», которого нет здесь: «{{place}}». Записывается только отмеченное.",
    "unavailableConfirm": "Сохранить",
    "unavailableOpen": "Оборудование здесь недоступно",
    "unavailableOpenHint": "Спрашивает, какого оборудования для этого упражнения нет.",
    "unavailableBadge": "Здесь нет",
    "unavailableRestore": "Снова доступно здесь",
    "unavailableErrorTitle": "Не удалось сохранить",
    "unavailableErrorBody": "Оборудование по-прежнему считается доступным здесь.",
    "unavailableConfirmHint": "Отметьте хотя бы одно, чтобы сохранить.",
    "pinDefaultMachine": "Всегда использовать тренажёр по умолчанию здесь",
    "pinMachine": "Всегда использовать {{machine}} здесь",
    "pinHint": "Перестаёт спрашивать, какой тренажёр, в этом зале, для этого упражнения.",
    "pinErrorTitle": "Не удалось сохранить",
    "pinErrorBody": "Основной тренажёр здесь не изменился.",
    "unpinDefaultMachine": "Больше не использовать здесь тренажёр по умолчанию",
    "unpinMachine": "Больше не использовать здесь {{machine}}",
    "pinnedFootnoteDefault": "Здесь всегда используется тренажёр по умолчанию.",
    "pinnedFootnoteMachine": "Здесь всегда используется {{machine}}.",
    "unpinHint": "Снова спрашивает, какой тренажёр, в этом зале, для этого упражнения."
  },
  "tabs": {
    "workout": "Тренировка",
    "plan": "План",
    "progress": "Прогресс",
    "profile": "Профиль",
    "catalog": "Каталог",
    "admin": "Админ",
    "workoutEyebrow": "Сегодняшняя сессия",
    "planEyebrow": "Планирование",
    "progressEyebrow": "Графики и отчёты",
    "profileEyebrow": "Аккаунт и максимумы",
    "catalogEyebrow": "Каталог упражнений",
    "adminEyebrow": "Админ-консоль",
    "progressEmpty": "Сначала запишите сессию — графики появятся, когда будут данные."
  },
  "shell": {
    "navAria": "Основная навигация"
  },
  "theme": {
    "aria": "Тема",
    "light": "Светлая",
    "dark": "Тёмная",
    "auto": "Авто"
  },
  "import": {
    "title": "Импорт тренировок из CSV",
    "help": "Загрузите экспорт из другого трекера. Подтверждаете, что вы владелец данных и берёте на себя ответственность за то, что импортируется в JackedLogs. Уже импортированные тренировки определяются по id и пропускаются.",
    "sourceLabel": "Источник",
    "source": {
      "strengthlog": "StrengthLog"
    },
    "sourceHint": {
      "strengthlog": "В StrengthLog: откройте Настройки, выберите Export, затем Logs full export. Сохраните CSV куда угодно и выберите файл ниже. Имя исходного файла значения не имеет."
    },
    "languageDisclaimer": "Названия упражнений сопоставляются по-английски. Названия на других языках создаются как черновики, переименовать их можно вручную в каталоге.",
    "consent": "Я сам экспортировал этот файл из своего аккаунта и являюсь владельцем данных.",
    "fileLabel": "CSV-файл",
    "parsing": "Чтение файла…",
    "cancel": "Отмена",
    "confirm": "Начать импорт",
    "again": "Импортировать другой файл",
    "done": "Импорт завершён",
    "seedMaxesPrompt": "Заполнить MAX из импортированных тренировок? Во вкладке «Профиль» есть предложение в один клик на основе каждого импортированного подхода.",
    "seedMaxesGo": "Заполнить MAX из истории",
    "summary": {
      "rows": "{{count}} строк",
      "sessions": "{{count}} сессий",
      "exercises": "{{count}} упражнений",
      "dateRange": "с {{from}} по {{to}}",
      "autoMatched": "{{count}} найдены в каталоге",
      "draftsToCreate": "{{count}} упражнений будут созданы как черновики",
      "unparseable": "{{count}} имён не дают slug и будут пропущены",
      "unparseableShow": "Показать имена"
    },
    "draftsCallout": "Черновики помечены auto_imported и сразу пригодны для записи тренировок. Позже атлет или тренер может их пересмотреть и утвердить, добавить мышцы и инвентарь или объединить дубли.",
    "draftsProgress": "Создание черновиков: {{done}} / {{total}}",
    "mappingsTitle": "Сопоставление упражнений",
    "mappingsStats": "{{matched}} сопоставлены автоматически · {{pending}} ждут решения · {{resolved}} решены · {{skipped}} пропущены",
    "allResolved": "Все упражнения готовы. Можно запускать импорт.",
    "confidenceHint": "Ближайшее: {{top}} ({{pct}}%)",
    "toggle": {
      "showResolved": "Показать решённые ({{count}})",
      "hideResolved": "Скрыть решённые",
      "showMatched": "Показать автосопоставленные ({{count}})",
      "hideMatched": "Скрыть автосопоставленные"
    },
    "action": {
      "create": "Создать как новое упражнение",
      "pickExisting": "Выбрать существующее",
      "skip": "Пропустить"
    },
    "create": {
      "name": "Название упражнения",
      "bodyweight": "Упражнение с собственным весом (без внешней нагрузки)",
      "submit": "Создать",
      "submitting": "Создание…"
    },
    "pick": {
      "label": "Упражнение из каталога",
      "placeholder": "Выберите…",
      "rememberAlias": "Запомнить «{{csvName}}» как алиас для будущих импортов",
      "submit": "Подтвердить",
      "submitting": "Сохранение…"
    },
    "skip": {
      "help": "Подходы по этому упражнению не будут импортированы. Решение можно изменить ниже.",
      "submit": "Подтвердить пропуск"
    },
    "resolved": {
      "auto": "→ {{name}} (авто)",
      "linked": "→ {{name}} (привязано)",
      "linkedAlias": "→ {{name}} (привязано, алиас сохранён)",
      "created": "→ {{name}} (создано)",
      "skipped": "пропущено",
      "undo": "Отмена"
    },
    "mapping": {
      "suggestions": "Подсказки",
      "allCatalog": "Весь каталог"
    },
    "progress": {
      "label": "{{done}} / {{total}} ({{pct}}%)",
      "tally": "Создано {{created}} · Уже есть {{duplicates}} · Ошибок {{failed}}"
    },
    "report": {
      "created": "Создано тренировок: {{count}}",
      "duplicates": "Уже есть: {{count}}",
      "draftsCreated": "Создано черновиков упражнений: {{count}}",
      "invalid": "Неверные данные: {{count}}",
      "unknownExercise": "Неизвестное упражнение: {{count}}",
      "failed": "Ошибок: {{count}}",
      "detailsToggle": "Показать ошибки",
      "moreFailures": "и ещё {{more}}"
    },
    "errors": {
      "catalogNotReady": "Каталог упражнений ещё загружается. Подождите и выберите файл снова.",
      "emptyFile": "В файле нет строк.",
      "missingColumns": "Отсутствуют обязательные столбцы: {{columns}}.",
      "parseFailed": "Не удалось прочитать файл.",
      "nothingToImport": "После создания черновиков импортировать нечего. Проверьте файл.",
      "draftsFailed": "Не удалось создать черновики: {{message}}"
    }
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Грудь",
        "biceps": "Бицепс",
        "triceps": "Трицепс",
        "forearm": "Предплечья",
        "front-deltoids": "Плечи",
        "back-deltoids": "Задние дельты",
        "trapezius": "Трапеции",
        "upper-back": "Спина",
        "lower-back": "Поясница",
        "abs": "Кор",
        "obliques": "Кор",
        "quadriceps": "Квадрицепс",
        "hamstring": "Бицепс бедра",
        "gluteal": "Ягодицы",
        "adductors": "Аддукторы",
        "abductors": "Абдукторы",
        "calves": "Икры",
        "tibialis": "Передняя большеберцовая",
        "neck": "Шея",
        "head": "Голова"
      }
    },
    "tabs": {
      "workouts": "Тренировки",
      "plan": "Главная",
      "progress": "Прогресс",
      "catalog": "Каталог",
      "profile": "Профиль",
      "settings": "Настройки",
      "inbox": "Входящие",
      "athletes": "Спортсмены",
      "me": "Я"
    },
    "me": {
      "sectionTraining": "Тренировки",
      "navTargets": "Цели",
      "navTargetsSub": "Ваши недельные цели"
    },
    "settings": {
      "title": "Настройки",
      "exercisesSection": "Упражнения",
      "navExercisesSub": "Максимумы, каталог, шкала усилия",
      "navCatalog": "Каталог упражнений",
      "selectPrompt": "Выберите настройку, чтобы открыть её.",
      "navCatalogSub": "Просмотр библиотеки упражнений",
      "navEffort": "Настройки усилия",
      "navEffortSub": "Шкала RIR / RPE + легенда",
      "navLicenses": "Лицензии open source",
      "navLicensesSub": "Библиотеки, на которых работает приложение",
      "sectionAccount": "Аккаунт",
      "sectionTraining": "Тренировка",
      "sectionBody": "Тело",
      "sectionPrefs": "Настройки",
      "sectionCoach": "Тренер",
      "sectionAbout": "О приложении",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Синхронизируйте тренировки и данные о здоровье с устройства"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "JackedLogs",
      "pillLabel": "Источники калорий",
      "projectionNote": "Включает подход, который ты вот-вот выполнишь: прогноз на всю тренировку, а не уже записанную работу.",
      "selected": "выбрано"
    },
    "hc": {
      "preferences": "Настройки",
      "caloriesWins": "Health Connect имеет приоритет для калорий",
      "caloriesWinsHelp": "Когда есть оба значения, показывать калории, измеренные через Health Connect, вместо оценки JackedLogs. Выкл. — предпочесть оценку. Без значения из Health Connect всегда используется оценка.",
      "title": "Health Connect",
      "intro": "Импортируйте активность с часов и телефона в JackedLogs. Прогулки, походы и велозаезды становятся тренировками; пульс и калории дополняют записанные вами сессии. Выключено, пока вы не подключите.",
      "checking": "Проверка…",
      "unavailable": "Health Connect недоступен на этом устройстве.",
      "updateRequired": "Обновите приложение Health Connect, чтобы продолжить.",
      "notConnected": "Не подключено.",
      "connect": "Подключить Health Connect",
      "connectHelp": "Вы выбираете, какие данные может читать JackedLogs. Изменить можно в любой момент в Health Connect.",
      "connected": "Подключено",
      "reads": "Читает тренировки, пульс и калории.",
      "syncNow": "Синхронизировать",
      "neverSynced": "Ещё не синхронизировано.",
      "lastSyncedAt": "Последняя синхронизация: {{when}}",
      "syncDelayNote": "Новой активности может понадобиться несколько минут, чтобы попасть в Health Connect с вашего устройства — недавняя прогулка или поездка может появиться только при следующей синхронизации. Такая задержка — это нормально.",
      "syncFullHistory": "Синхронизировать всю историю",
      "syncingFullHistory": "Синхронизация всей истории",
      "syncFullHistoryHelp": "Перепроверяет всю историю и заполняет пробелы в Health Connect. Используйте, если там не хватает прошлой правки. Можно повторять без риска.",
      "resultSummary": "{{imported}} импортировано · {{enriched}} дополнено · {{skipped}} пропущено",
      "error": "Что-то пошло не так. Попробуйте ещё раз.",
      "manageInHc": "Управлять в Health Connect",
      "disconnect": "Отключить",
      "disconnectTitle": "Отключить Health Connect?",
      "disconnectBody": "JackedLogs перестанет читать ваши данные Health Connect. Уже импортированные тренировки останутся в истории.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Ваши данные",
      "privacyBody": "JackedLogs читает только то, что вы разрешили в Health Connect, и только на этом телефоне после подключения. Данные хранятся в вашем личном аккаунте JackedLogs, никогда не передаются и не продаются. Отключите в любой момент, чтобы остановить.",
      "bodyResult": "Импортировано тела: {{imported}} · пропущено: {{skipped}}",
      "bodyNotGranted": "Данные тела ещё не разрешены. Нажмите Разрешить данные тела.",
      "readsFull": "Читает тренировки, пульс и калории, вес и состав тела, глюкозу и питание. Записывает глюкозу обратно в Health Connect.",
      "backfillTitle": "Импортировать историю с мая?",
      "backfillBody": "Просматривает историю Health Connect до мая и импортирует то, чего нет. Можно запускать повторно: уже импортированное пропускается.",
      "backfillNow": "Импортировать историю",
      "grantExtra": "Разрешить данные здоровья",
      "extraGrantBody": "Импортируй также вес, состав тела, глюкозу и питание.",
      "metabolicResult": "Импортировано: глюкоза {{glucose}} · питание {{nutrition}}",
      "metabolicNotGranted": "Глюкоза и питание ещё не разрешены.",
      "writeGlucoseGrantBody": "Разрешить JackedLogs записывать глюкозу в Health Connect.",
      "grantWrite": "Разрешить запись",
      "syncGlucoseToHc": "Записать глюкозу в Health Connect"
    },
    "metabolic": {
      "title": "Метаболизм",
      "loading": "Загрузка…",
      "empty": "Подключите Health Connect и синхронизируйте, чтобы видеть здесь глюкозу и питание.",
      "glucoseEmpty": "Нет измерений глюкозы",
      "glucoseLatest": "Последняя глюкоза",
      "mgdl": "мг/дл",
      "targetBand": "Типичный целевой диапазон {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Углеводы сегодня",
      "grams": "г",
      "glucoseTitle": "Глюкоза",
      "glucoseCurrent": "Последнее: {{value}} {{unit}}",
      "glucoseNone": "Запишите значение, чтобы отслеживать глюкозу."
    },
    "exercisesScreen": {
      "back": "Назад"
    },
    "body": {
      "back": "Назад",
      "title": "Тело",
      "navTitle": "Тело",
      "navSub": "Пол, возраст, фигура, карта боли",
      "trendsWebHint": "Графики состава тела находятся в мобильном приложении.",
      "sexLabel": "Пол",
      "sexHelp": "Используется только для оценки процента жира. Фигура на карте мышц — отдельный выбор ниже.",
      "sex_male": "Мужской",
      "sex_female": "Женский",
      "measurementsTitle": "Замеры",
      "measurementsSub": "Вес, обхваты, оценка процента жира",
      "measureTitle": "НОВЫЙ ЗАМЕР",
      "weight": "Вес",
      "field_heightCm": "Рост",
      "field_neckCm": "Шея",
      "field_chestCm": "Грудь",
      "field_waistCm": "Талия",
      "field_hipsCm": "Бёдра",
      "field_bicepsLCm": "Бицепс (Л)",
      "field_bicepsRCm": "Бицепс (П)",
      "field_forearmsLCm": "Предплечье (Л)",
      "field_forearmsRCm": "Предплечье (П)",
      "field_thighsLCm": "Бедро (Л)",
      "field_thighsRCm": "Бедро (П)",
      "field_calvesLCm": "Голень (Л)",
      "field_calvesRCm": "Голень (П)",
      "measureSave": "Сохранить введённые значения",
      "measureHelpC": "Заполняйте только то, что измерили. Пустые поля не сохраняются.",
      "useLastA11y": "Использовать прошлое значение {{value}}",
      "saveFailedTitle": "Не удалось сохранить",
      "saveFailedBody": "Замер не сохранён. Значения сохранены — нажмите «Сохранить», чтобы повторить.",
      "editTitle": "ИЗМЕНИТЬ — {{date}}",
      "saveChanges": "Сохранить изменения",
      "editCancelA11y": "Отменить изменение",
      "editRowA11y": "Изменить замер {{date}}",
      "editHelp": "Измените значение или очистите его, чтобы удалить из истории.",
      "trendsLabel": "ТРЕНДЫ",
      "trendsHint": "выбор метрик",
      "trendsExpandA11y": "Показать все метрики",
      "trendsCollapseA11y": "Свернуть метрики",
      "trendsEmpty": "Сделайте минимум 2 замера, чтобы увидеть тренд.",
      "metricComposition": "Состав",
      "metricBodyFat": "Жир",
      "metricLeanMass": "Сухая масса",
      "loadError": "Не удалось загрузить замеры — проверьте соединение.",
      "queuedNote": "Ожидают синхронизации: {{count}}",
      "navyTitle": "СОСТАВ ТЕЛА (NAVY)",
      "navyNeedsEntry": "Сохраните замер ниже, чтобы оценить процент жира.",
      "navyNeedsSex": "Укажите пол выше, чтобы оценить процент жира.",
      "navyNeedsInputs": "Добавьте рост, шею и талию (и бёдра для женской формулы), чтобы оценить процент жира.",
      "navyBodyFat": "Жир ≈ {{pct}}%",
      "navyLeanMass": "Сухая масса ≈ {{mass}}",
      "navyDisclaimer": "Оценка US Navy (~±3,5%). Смотрите на динамику, а не на одно число.",
      "historyEmpty": "Замеров пока нет. Сохраните один выше, чтобы начать отслеживание.",
      "historyTitle": "ИСТОРИЯ",
      "trendWeight": "ДИНАМИКА ВЕСА",
      "trendBodyFat": "ДИНАМИКА ЖИРА",
      "deleteTitle": "Удалить замер?",
      "deleteEmptyTitle": "Удалить этот замер?",
      "deleteEmptyBody": "Все его значения очищены, поэтому запись будет удалена.",
      "deleteCancel": "Отмена",
      "deleteConfirm": "Удалить",
      "ageLabel": "Возраст",
      "ageHelp": "Необязательно. Нажмите ещё раз, чтобы очистить.",
      "dualCurveLegend": "Сплошная: оценка · Пунктир: Health Connect",
      "bodyFatProvenance": "Процент жира рассчитывается по обхвату талии и шеи.",
      "bodyFatProvenanceWithHips": "Процент жира рассчитывается по обхвату талии, шеи и бёдер."
    },
    "effortSettings": {
      "back": "Назад",
      "title": "Усилие",
      "scaleLabel": "Шкала усилия",
      "scaleHelp": "Какую шкалу использует логгер. RIR = повторений в запасе; RPE = воспринимаемое усилие. RPE = 10 − RIR, то есть это одно усилие на двух шкалах."
    },
    "plan": {
      "currentBlockError": "Не удалось задать текущий блок. Попробуйте ещё раз.",
      "currentBlockOn": "Текущий блок — нажмите, чтобы открепить",
      "currentBlockOff": "Сделать текущим блоком",
      "currentBlockHint": "Закрепляет недельные цели этой программы на счётчике главной",
      "title": "План",
      "start": "Старт",
      "starting": "Открытие…",
      "programWeekSession": "Неделя {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Последняя: Н{{week}} · {{session}}",
      "programNextHeader": "Следующая",
      "programStartCta": "▶ Начать {{session}}",
      "programChangeLink": "Изменить неделю или сессию ›",
      "carouselPosition": "Программа {{n}} из {{total}}",
      "carouselPrev": "Предыдущая программа",
      "carouselNext": "Следующая программа",
      "programWeekLabel": "Неделя",
      "singleCycle": "Один цикл, каждая неделя одинаковая",
      "programSessionLabel": "Сессия",
      "programWeekShort": "Н{{n}}",
      "programDayShort": "Д{{n}}",
      "sessionN": "Сессия {{n}}",
      "sessionNShort": "С{{n}}",
      "programConfirm": "Старт Н{{week}} · {{session}}",
      "cancel": "Отмена",
      "newWorkout": "Новая тренировка",
      "programsHint": "Многонедельные циклы, которые автоматически продвигаются по мере записи тренировок.",
      "planDeleteTitle": "Удалить план?",
      "programDeleteTitle": "Удалить программу?",
      "programStatusError": "Не удалось обновить программу. Попробуйте снова.",
      "view": "Показать",
      "hide": "Скрыть",
      "programUnfollowHint": "Перестать следовать программе (останется в «Мои программы»)",
      "programNextInline": "Далее: W{{week}} · {{session}}",
      "programStartA11y": "Начать {{session}}",
      "startPlanA11y": "Начать {{name}}"
    },
    "preview": {
      "muscles": "Мышцы",
      "noSets": "Подходы не заданы",
      "alternates": "Альтернативы: {{names}}",
      "gridTitle": "Интенсивность · день × неделя",
      "gridHint": "Коснитесь дня, чтобы увидеть упражнения.",
      "matrixTitle": "Интенсивность · по подходам",
      "matrixHint": "Коснитесь упражнения, чтобы увидеть подходы.",
      "restDay": "Отдых / лёгкий",
      "intensity": {
        "work": "работа",
        "moderate": "умеренно",
        "heavy": "тяжело",
        "max": "Макс",
        "free": "свободно"
      }
    },
    "catalog": {
      "title": "Каталог",
      "search": "Поиск упражнений",
      "empty": "Нет подходящих упражнений.",
      "back": "Назад",
      "notFound": "Упражнение не найдено.",
      "metaPrimaryMuscle": "Основная мышца",
      "metaPattern": "Паттерн",
      "metaEquipment": "Оборудование",
      "metaP1RM": "Программируемое",
      "metaP1RMYes": "Да",
      "metaP1RMNo": "Нет",
      "metaDefaultBar": "Гриф по умолчанию",
      "metaBarLoading": "Загрузка грифа",
      "metaBarLoadingLandmine": "Лендмайн (один конец)",
      "aliasesLabel": "Также известно как",
      "tagsLabel": "Теги",
      "historyLabel": "Недавние тренировки",
      "historyEmpty": "Нет прошлых тренировок по этому упражнению.",
      "historyError": "Не удалось загрузить историю.",
      "historyBodyweight": "{{reps}} повторов BW",
      "recordsLabel": "Рекорды",
      "recordsEmpty": "Пока нет рекордов.",
      "selectPrompt": "Выберите упражнение, чтобы увидеть детали.",
      "recordsError": "Не удалось загрузить рекорды.",
      "refreshing": "Обновление…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Назад",
      "search": "Поиск упражнений",
      "empty": "Нет подходящих упражнений.",
      "editCancel": "Отмена",
      "editSave": "Сохранить",
      "errInvalid": "Введите корректный вес.",
      "clearAction": "Убрать MAX",
      "clearTitle": "Убрать этот MAX?",
      "clearBody": "Значение и история сохранятся на сервере, но MAX будет считаться неустановленным.",
      "clearCancel": "Отмена",
      "clearConfirm": "Убрать",
      "selectPrompt": "Выберите упражнение, чтобы задать его MAX."
    },
    "login": {
      "title": "JackedLogs",
      "subtitle": "Войди в свой аккаунт",
      "submit": "Войти"
    },
    "workouts": {
      "title": "Тренировки",
      "empty": "Тренировок пока нет.",
      "fallbackName": "Тренировка",
      "endOfList_one": "{{count}} тренировка, конец списка.",
      "endOfList_few": "{{count}} тренировки, конец списка.",
      "endOfList_many": "{{count}} тренировок, конец списка.",
      "endOfList_other": "{{count}} тренировок, конец списка.",
      "newButton": "Новая",
      "queuedBanner_one": "{{count}} тренировка в очереди. Нажми для повтора.",
      "queuedBanner_few": "{{count}} тренировки в очереди. Нажми для повтора.",
      "queuedBanner_many": "{{count}} тренировок в очереди. Нажми для повтора.",
      "queuedBanner_other": "{{count}} тренировок в очереди. Нажми для повтора.",
      "maxQueuedBanner_one": "{{count}} MAX в очереди. Отправится сам, когда появится сеть.",
      "maxQueuedBanner_few": "{{count}} MAX в очереди. Отправятся сами, когда появится сеть.",
      "maxQueuedBanner_many": "{{count}} MAX в очереди. Отправятся сами, когда появится сеть.",
      "maxQueuedBanner_other": "{{count}} MAX в очереди. Отправятся сами, когда появится сеть.",
      "maxQueuedHint": "Нажми, чтобы синхронизировать сейчас.",
      "maxConfirmFailedTitle": "MAX не сохранён",
      "maxConfirmFailedBody": "Сервер не принял это значение, поэтому ничего не записано. Твой MAX не изменился. Его можно задать вручную в разделе Я, Максимумы.",
      "queuedRetry": "Повторить",
      "queuedDetail": "Детали",
      "queuedHint": "Нажми, чтобы повторить, удерживай — чтобы отбросить.",
      "queuedHintDetail": "Нажми, чтобы увидеть очередь, удерживай — чтобы отбросить.",
      "queueDismissTitle": "Отбросить тренировки в очереди?",
      "queueDismissBody_one": "{{count}} тренировка будет удалена и не сохранена.",
      "queueDismissBody_few": "{{count}} тренировки будут удалены и не сохранены.",
      "queueDismissBody_many": "{{count}} тренировок будут удалены и не сохранены.",
      "queueDismissBody_other": "{{count}} тренировок будут удалены и не сохранены.",
      "queueDismissCancel": "Отмена",
      "queueDismissConfirm": "Отбросить",
      "editUnsupportedTitle": "Редактирование пока недоступно на мобильном",
      "editUnsupportedBody": "Эта тренировка содержит типы упражнений (P1RM, loaded carry), которые мобильный логгер пока не редактирует. Открой её в веб-приложении.",
      "editUnsupportedAck": "OK",
      "maxBumpHeader_one": "{{count}} новый MAX",
      "maxBumpHeader_few": "{{count}} новых MAX",
      "maxBumpHeader_many": "{{count}} новых MAX",
      "maxBumpHeader_other": "{{count}} новых MAX",
      "maxBumpRow": "{{exercise}}: {{valueKg}} кг",
      "maxBumpConfirm": "Подтвердить",
      "maxBumpDismiss": "Пропустить",
      "repeat": "Повторить тренировку",
      "resumePillAction": "Продолжить",
      "resumePillFallback": "Тренировка идёт",
      "cancel": "Отмена",
      "loadOlder": "Загрузить прежние месяцы",
      "selectPrompt": "Выберите тренировку, чтобы увидеть сводку.",
      "loadError": "Не удалось загрузить эту тренировку.",
      "maxDropRow": "{{exercise}}: MAX мог снизиться до {{valueKg}} кг (был {{currentKg}}, {{weeks}} нед. назад)",
      "maxDropConfirm": "Снизить до {{valueKg}}",
      "maxDropKeep": "Оставить {{valueKg}}",
      "maxDropBadDay": "Плохой день",
      "importedBadge": "Импортировано"
    },
    "outboxDetail": {
      "title": "Тренировки в очереди",
      "close": "Закрыть",
      "empty": "Очередь пуста.",
      "statusQueued": "В очереди",
      "statusSending": "Отправка",
      "statusFailed4xx": "Сервер отклонил",
      "statusPermanentFail": "Отказ",
      "attempts_one": "{{count}} попытка",
      "attempts_few": "{{count}} попытки",
      "attempts_many": "{{count}} попыток",
      "attempts_other": "{{count}} попыток",
      "dismissOne": "Отбросить",
      "dismissOneTitle": "Отбросить эту тренировку?",
      "dismissOneBody": "Тренировка от {{date}} будет удалена без сохранения.",
      "dismissCancel": "Отмена",
      "dismissConfirm": "Отбросить",
      "retryAll": "Повторить все",
      "dismissAll": "Отбросить все",
      "queueWorkout": "Тренировка",
      "queueWorkoutNote": "Заметка к тренировке",
      "queueMeasurement": "Измерение",
      "queueMax": "Максимум",
      "queueProfile": "Профиль",
      "queueHealth": "Данные здоровья",
      "queueMetabolic": "Метаболические данные",
      "queueRequest": "Изменение",
      "stuckTitle": "Незавершённые записи"
    },
    "stuckWrites": {
      "banner_one": "{{count}} запись не прошла",
      "banner_few": "{{count}} записи не прошли",
      "banner_many": "{{count}} записей не прошло",
      "banner_other": "{{count}} записей не прошло",
      "retry": "Повторить",
      "retrying": "Новая попытка…",
      "details": "Подробности"
    },
    "progress": {
      "title": "Прогресс",
      "windowAll": "Недавние тренировки",
      "window30d": "Последние 30 дней",
      "window7d": "Последние 7 дней",
      "lastSession": "Последняя тренировка",
      "frequencyTitle": "Недельная частота",
      "frequencyHelp": "Тренировки за неделю, последние {{weeks}} недель (текущая неделя справа).",
      "recordsTitle": "Рекорды",
      "recordsHelp": "Лучшие рекорды на повтор по упражнениям. Сначала свежие.",
      "recordsAllTime": "За всё время",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Фильтр по упражнению",
      "recordsNoMatch": "Под фильтр ничего не подходит.",
      "tagVolumeTitle": "Объём по тегам",
      "tagVolumeHelp": "Тренировочный объём по мышцам/тегам за недавний период.",
      "recordsEmpty": "Пока нет рекордов — запиши несколько подходов с весом.",
      "chartE1rm": "Оценочный 1ПМ",
      "chartVolume": "Объём",
      "chartScope": "По последним {{n}} тренировкам.",
      "chartLoadFailed": "Не удалось загрузить график.",
      "chartEmpty": "Нет подходов с весом в недавнем окне.",
      "viewByExercise": "По упражнению",
      "viewByTag": "По тегу",
      "noTags": "Нет упражнений с тегами в недавнем окне.",
      "totalVolume": "Всего: {{weight}}",
      "chartMax": "MAX (кг)",
      "chartEstimatedBadge": "наложение e1RM",
      "prFound": "Новый рекорд: {{weight}}",
      "prUpdate": "Обновить MAX до {{weight}}",
      "prUpdating": "Обновляю…",
      "painSeverity": {
        "red": "красный",
        "yellow": "жёлтый",
        "green": "зелёный"
      },
      "balance": {
        "title": "Баланс паттернов движений",
        "help": "Подходы и объём по каждому паттерну движения за выбранное окно в {{days}} дн., отсортированные по числу подходов. Маленькое число «X/7д» — счётчик за последние 7 дней, помогает заметить недавний всплеск (или сознательное снижение), который скрывается за более длинным окном."
      },
      "empty": "Нет недавней активности для сравнения",
      "pain": {
        "title": "Боль × объём",
        "help": "Для каждой мышцы, отмеченной сейчас в painMap, показана недавняя тренировочная нагрузка. Красная точка — боль красного уровня (избегайте тяжёлых нагрузок), жёлтая — осторожно, зелёная — наблюдайте. Два числа объёма — нагрузка на эту мышцу за последние 7 дней и за выбранное окно в {{days}} дн.; устойчивая тяжёлая нагрузка на красную мышцу — самый высокорисковый сигнал на панели.",
        "noPain": "Нет мышц, отмеченных в painMap",
        "sevRed": "Избегать",
        "sevYellow": "Осторожно",
        "sevGreen": "Наблюдать"
      },
      "trends": {
        "a11yUp": "прогресс",
        "a11yFlat": "плато",
        "a11yDown": "регресс",
        "title": "Тренды E1RM",
        "help": "Для каждого паттерна движения (присед, тяга, жим, тяга к себе, …) показано упражнение, в котором у вас наивысший e1RM. График — точки e1RM за выбранное окно в {{days}} дн. (нажмите точку, чтобы увидеть значение). Стрелка — тренд за это окно: ↗ прогресс, → плато, ↘ регресс. Метка «Мало данных» появляется, когда для построения линии меньше 3 точек.",
        "fewData": "Мало данных за {{days}} дн",
        "notMeasurable": "Пока не измеримо: ни один ваш подход {{name}} не дошёл до предела. Подход, доведённый почти до отказа (AMRAP), показал бы вашу силу здесь.",
        "machineNotMeasurable": "{{value}}, пока не измеримо",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Показать другой тренажёр.",
        "machineA11y_few": "{{exercise}}, {{machine}}. Показать ещё {{count}} тренажёра.",
        "machineA11y_many": "{{exercise}}, {{machine}}. Показать ещё {{count}} тренажёров.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Показать ещё {{count}} тренажёров.",
        "machineSessions_one": "{{count}} тренировка",
        "machineSessions_few": "{{count}} тренировки",
        "machineSessions_many": "{{count}} тренировок",
        "machineSessions_other": "{{count}} тренировок"
      },
      "repsAtLoad": {
        "a11yUp": "рост",
        "a11yFlat": "ровно",
        "a11yDown": "спад",
        "title": "Повторы при фиксированном весе",
        "help": "Для упражнений, где вы повторяете один и тот же вес, показывает, как меняются повторы при этом фиксированном весе за выбранное окно в {{days}} дн. — прирост силы, который график e1RM не видит на многоповторной работе и тренажёрах. График — повторы при весе во времени (нажмите точку). Стрелка — тренд: ↗ рост, → ровно, ↘ спад. Учитываются только подходы с отмеченным усилием, поэтому больше повторов не может означать просто более лёгкий день.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Мало данных за {{days}} дн",
        "notMeasurable": "Пока не измеримо: у ваших подходов {{name}} с весом {{load}} не отмечено усилие, поэтому больше повторов может означать просто более лёгкий день. Подход, доведённый почти до отказа, — или отмеченное усилие — показал бы здесь вашу силу."
      },
      "period": {
        "all": "всё"
      },
      "loadFailed": "Не удалось загрузить",
      "density": {
        "title": "Плотность",
        "help": "Объём, делённый на длительность тренировки, kg/min. Читается как «насколько плотной была тренировка»: рост означает, что вы выполняете ту же нагрузку за меньшее время (лучше выносливость) или большую нагрузку за то же время (лучше сила). Резкое падение без изменения программы часто говорит об усталости: отдых растянулся, даже если вы этого не планировали.",
        "empty": "Нужно 3+ тренировок с замером времени для графика плотности"
      },
      "frequency": {
        "title": "Самые забытые упражнения",
        "help": "Топ-8 упражнений, отсортированных по числу дней с последнего выполнения, самые забытые — первыми. Суффикс X/{{days}}д — количество подходов за выбранное окно. Числа красным — 14+ дней без работы: либо вы сознательно их убрали, либо программа сдвинулась. Полезно, чтобы заметить вспомогательную работу, которая тихо исчезла.",
        "today": "сегодня",
        "daysAgo": "{{n}} д назад"
      },
      "fatigueDrift": {
        "title": "Дрейф усталости (RIR)",
        "help": "Скользящее недельное среднее RPE и резерва повторений по подходам, в которых записано и то и другое. RPE растёт, а RIR падает при схожих нагрузках = накопленная усталость проявляется ещё до того, как штанга замедлится. Разгрузочная неделя обычно её снимает.",
        "noData": "Записывайте RPE и RIR в нескольких подходах, чтобы построить график дрейфа усталости",
        "rising": "Усталость растёт",
        "stable": "Стабильно",
        "legend": "RPE (слева) · RIR (справа) — нажмите неделю для значений"
      },
      "intensityHeatmap": {
        "title": "Тепловая карта интенсивности",
        "help": "Сетка выполненных подходов по упражнениям, отсортированная по диапазону повторений и интенсивности (% от 1ПМ). Силовой диапазон (85%+) в правом нижнем углу, гипертрофия в центре, выносливость в левом верхнем. Выбери упражнение, чтобы увидеть, где сосредоточены его подходы.",
        "exerciseLabel": "Упражнение",
        "choosePrompt": "Выбери упражнение",
        "noEligible": "Зафиксируй 1ПМ хотя бы для одного упражнения, чтобы рассчитать интенсивность.",
        "noMax": "Для этого упражнения 1ПМ ещё не записан.",
        "totalSets": "{{n}} подх. · 1ПМ {{max}}",
        "clear": "Нет"
      },
      "a11y": {
        "severityAlarm": "Тревога",
        "severityWarn": "Предупреждение",
        "severityInfo": "Инфо",
        "stale": "Неактивно"
      }
    },
    "profile": {
      "title": "Профиль",
      "navMaxes": "MAX",
      "navMaxesSub": "Устанавливай, изменяй и просматривай свои MAX по упражнениям.",
      "navCatalogSub": "Просмотр упражнений, рекордов и истории.",
      "navRestTimer": "Таймеры",
      "navRestTimerSub": "Отдых + удержание, звук, по упражнению",
      "labelEmail": "EMAIL",
      "labelApp": "ВЕРСИЯ ПРИЛОЖЕНИЯ",
      "labelBackend": "ВЕРСИЯ БЭКЕНДА",
      "labelPrivacy": "КОНФИДЕНЦИАЛЬНОСТЬ",
      "privacyHelp": "Экспортируй всё в JSON или удали аккаунт навсегда.",
      "exportButton": "Экспорт моих данных",
      "deleteButton": "Удалить мой аккаунт",
      "deleteAlertTitle": "Удалить аккаунт",
      "deleteAlertBody": "Твой аккаунт, тренировки, планы, программы и максимумы будут удалены навсегда. Удаление необратимо.",
      "deleteAlertCancel": "Отмена",
      "deleteAlertConfirm": "Удалить",
      "signOut": "Выйти",
      "exportShareTitle": "Экспорт JackedLogs {{date}}",
      "labelLanguage": "Язык",
      "languageHelp": "Выбери язык приложения. Сохраняется на этом устройстве.",
      "languageCancel": "Закрыть"
    },
    "timeline": {
      "setNumber": "Подход {{n}}",
      "fail": "Не выполнен",
      "failTip": "«Не выполнен» записывает подход как попытку без завершения. Он всё равно считается выполненным (запускается таймер отдыха), показывает ✕ в ленте и не учитывается в вашем e1RM.",
      "failTipA11y": "Что значит «Не выполнен»?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% от лучшего",
      "e1rmNewBest": "рекорд",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Миреп",
      "dropsetTag": "Дроп",
      "myorepA11y": "Мио-повтор подход",
      "dropsetA11y": "Дроп-сет",
      "setVolumeA11y": "Объём подхода {{value}} {{unit}}",
      "setSummaryBothSidesA11y": "{{reps}} повторений по {{weight}} {{unit}} на сторону, учтены обе стороны",
      "e1rmLegendA11y": "Что такое e1RM?",
      "e1rmTip": "e1RM — расчётный максимум на 1 повтор для подхода (Эпли, повторы ≤ 12). «% от лучшего» сравнивает его с вашим лучшим e1RM за недавнее время: ниже — есть запас, чтобы прибавить; ↑ рекорд — новый расчётный максимум.",
      "durationLabel": "Длительность",
      "hourShort": "ч",
      "minShort": "мин",
      "secShort": "сек",
      "started": "Тренировка начата",
      "addSet": "Добавить подход",
      "removeSet": "Убрать подход",
      "prevSet": "Предыдущий подход",
      "nextSet": "Следующий подход",
      "allLogged": "Все подходы записаны — нажмите +, чтобы добавить ещё.",
      "rosterLabel": "Упражнения",
      "rosterHint": "нажмите для переключения",
      "focusEmptyHasRoster": "Выбери упражнение выше, чтобы начать, или добавь новое.",
      "focusAllLogged": "Все подходы записаны — добавь упражнение или сохрани ниже.",
      "cueNextSet": "→ Подход {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Развернуть список упражнений",
      "rosterCollapseA11y": "Свернуть список упражнений",
      "rosterState": {
        "done": "готово",
        "inProgress": "в процессе",
        "notDone": "не начато"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} из {{count}})",
      "exerciseNote": "Заметка к упражнению",
      "notePlaceholder": "Добавить заметку в ленту…",
      "noteSend": "Отправить заметку",
      "noteExpandA11y": "Заметка — нажмите, чтобы прочитать полностью",
      "noteDeleteA11y": "Удалить заметку",
      "dropsetActive": "Дропсет — измените раунды ниже.",
      "editingLogged": "Редактирование записанного подхода {{n}} — изменения сохранятся вместе с тренировкой.",
      "addSetLocked": "Редактирование прошлой тренировки: нельзя добавлять подходы. Исправьте значения или удалите подход.",
      "createGroupLocked": "Редактирование прошлой тренировки: нельзя создать суперсет.",
      "splitGroupLocked": "Редактирование прошлой тренировки: нельзя расформировать суперсет.",
      "setTypeLocked": "Редактирование прошлой тренировки: нельзя изменить тип подхода (дропсет/миореп).",
      "addStepLocked": "Редактирование прошлой тренировки: нельзя добавить шаг дропсета.",
      "setState": {
        "pending": "Подход {{n}} из {{total}}, не выполнен",
        "done": "Подход {{n}} из {{total}}, выполнен",
        "pr": "Подход {{n}} из {{total}}, личный рекорд",
        "failed": "Подход {{n}} из {{total}}, срыв"
      },
      "holdLabel": "Удержание"
    },
    "summary": {
      "prBadge": "личный рекорд"
    },
    "logger": {
      "title": "Новая тренировка",
      "cancel": "Отмена",
      "swapKindTitle": "Сменить тип упражнения?",
      "swapKindBody": "Это упражнение записывается иначе, поэтому уже внесённые здесь подходы будут удалены.",
      "swapKindConfirm": "Сменить и очистить",
      "failConfirmTitle": "Чистые повторы",
      "failConfirmBody_one": "Сохраняю {{count}} чистый повтор. Сорванный не считается.",
      "failConfirmBody_few": "Сохраняю {{count}} чистых повтора. Сорванный не считается.",
      "failConfirmBody_many": "Сохраняю {{count}} чистых повторов. Сорванный не считается.",
      "failConfirmBody_other": "Сохраняю {{count}} чистых повторов. Сорванный не считается.",
      "failConfirmHint": "Поправь, если сделал больше или меньше.",
      "failConfirmStepDown": "На один чистый повтор меньше",
      "failConfirmStepUp": "На один чистый повтор больше",
      "failConfirmSave": "Сохранить",
      "amrapConfirmTitle": "Дошли до отказа?",
      "amrapConfirmBody": "Отвечайте «да», только если следующее повторение уже не вышло бы.",
      "amrapNeedsReps": "Введите число повторений, чтобы записать подход.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: минимум {{reps}} повторений, затем как можно больше",
      "amrapConfirmAtFloor": "Записано: {{reps}}. Программа просила не менее {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Да, до отказа",
      "amrapConfirmNo": "Нет, запас оставался",
      "failBadge": "Срыв",
      "failBadgeA11y": "неудачный подход",
      "save": "Сохранить",
      "remove": "Убрать",
      "replace": "Заменить",
      "addExercise": "Добавить упражнение",
      "addSet": "Добавить подход",
      "addRound": "Добавить раунд",
      "pickerTitle": "Выбрать упражнение",
      "pickerSearch": "Поиск упражнений",
      "pickerEmpty": "Упражнения не найдены.",
      "pickerClearFilters": "Очистить фильтры",
      "pickerFilters": "Фильтры",
      "pickerFiltersN": "Фильтры ({{n}})",
      "empty": "Упражнений нет. Добавь, чтобы начать.",
      "setReps": "ПОВТ",
      "amrapPrescribedA11y": "AMRAP: минимум заданные повторения, затем сколько сможешь",
      "setWeight": "КГ",
      "setWeightLb": "ФУНТ",
      "setWeightBothSidesA11y": "Вес одной стороны, учтены обе стороны ({{unit}})",
      "setTypeWorking": "Обычный",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Мио-реп",
      "setCommentLabel": "Комментарий подхода",
      "unitLabel": "Единица",
      "discardTitle": "Отменить тренировку?",
      "discardBody": "Введённые подходы будут потеряны.",
      "discardCancel": "Продолжить",
      "discardConfirm": "Отменить",
      "errNoEntries": "Добавь хотя бы одно упражнение.",
      "errNoSets": "У каждого упражнения должен быть хотя бы один подход с повторениями и весом.",
      "errInvalid": "Тренировку нельзя сохранить в таком виде.",
      "errSaveFailed": "Сохранение не удалось. Нажми \"Повторить\" на баннере очереди, когда подключишься к сети.",
      "setNumberHeader": "СЕТ",
      "removeSetA11y": "Удалить этот подход",
      "serverErrorTitle": "СЕРВЕР ОТКЛОНИЛ СОХРАНЕНИЕ",
      "serverErrorHint": "Поправь тренировку и попробуй снова. Если сообщение непонятно, перешли его тренеру.",
      "setExtra": "ДОП",
      "bwPromptTitle": "Укажите ваш вес тела",
      "bwPromptBody": "Для упражнений с собственным весом нужен ваш вес, чтобы рассчитать нагрузку и объём. Укажите его в Настройки → Тело.",
      "bwPromptCta": "Указать",
      "setWeightTip": "Вес за подход. Переключайте кг/фунты чипом единиц в каждой строке.",
      "setExtraTip": "Помощь или добавленный вес для упражнений с собственным весом. Введите минус (−) для помощи резиной/тренажёром (поле станет янтарным); пояс/блин — положительный.",
      "setWeightMixedTip": "Смешанная группа: вес штанги/стека в силовых строках, ± добавка в строках с собственным весом (минус = помощь).",
      "editTitle": "Изменить тренировку",
      "repeatTitle": "Повторить тренировку",
      "minimize": "Свернуть тренировку",
      "closeWorkout": "Закрыть тренировку",
      "saveWorkout": "Сохранить тренировку",
      "bilateral": "Билатерально",
      "unilateral": "Унилатерально",
      "plates": "Блины",
      "numInvalid": "Неверное число",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Усилие 1–10",
      "setNoteLabel": "Заметка",
      "setNotePlaceholder": "Подсказка, техника, ощущения…",
      "elapsedA11y": "Прошло времени",
      "totalsSets_one": "{{count}} подход",
      "totalsSets_few": "{{count}} подхода",
      "totalsSets_many": "{{count}} подходов",
      "totalsSets_other": "{{count}} подходов",
      "totalsReps_one": "{{count}} повтор",
      "totalsReps_few": "{{count}} повтора",
      "totalsReps_many": "{{count}} повторов",
      "totalsReps_other": "{{count}} повторов",
      "totalsTitle": "Итоги тренировки",
      "totalsVolume": "Объём",
      "totalsSetsShort": "Подходы",
      "totalsRepsShort": "Повторы",
      "totalsByMuscle": "Нагрузка по мышцам",
      "restRest": "Отдых",
      "startRestManual": "Запустить отдых",
      "restSkip": "Пропустить",
      "restWord": "Отдых",
      "restAddStep": "+{{n}} секунд",
      "restSubtractStep": "−{{n}} секунд",
      "restRemainingA11y": "осталось отдыха: {{time}}",
      "restLockedA11y": "Редактирование заблокировано во время отдыха. Нажмите «Пропустить», чтобы изменить.",
      "restEditA11y": "Задать отдых по умолчанию для этого упражнения",
      "restEditTitle": "Отдых по умолчанию",
      "restEditBody": "Сохранить этот отдых как стандартный для {{name}}",
      "restEditSave": "Сохранить",
      "restEditSaving": "Сохраняем…",
      "restEditError": "Не удалось сохранить отдых по умолчанию. Попробуйте снова.",
      "restEditCancel": "Отмена",
      "restEditSaveAsGlobal": "Использовать как глобальный стандарт",
      "restStepMinus": "Уменьшить на {{step}} секунд",
      "restStepPlus": "Увеличить на {{step}} секунд",
      "restPause": "Пауза",
      "restResume": "Продолжить",
      "restExpiredTitle": "Отдых окончен",
      "holdExpiredTitle": "Время вышло",
      "restExpiredBody": "Пора снова поднимать.",
      "holdExpiredBody": "Коснитесь шкалы усилия, чтобы записать подход.",
      "boutExpiredTitle": "Интервал завершён",
      "boutExpiredBody": "Подход записан автоматически.",
      "boutAutoLoggedA11y": "Интервал завершён, записано {{time}}.",
      "workoutFgsTitle": "Тренировка идёт",
      "workoutFgsBodyNamed": "{{name}} · нажмите, чтобы продолжить",
      "workoutFgsBody": "Нажмите, чтобы продолжить тренировку",
      "descriptionToggle": "Показать / скрыть описание",
      "notesToggle": "Заметки тренера к этой тренировке",
      "notesProgramLabel": "Программа",
      "notesWorkoutLabel": "Эта тренировка",
      "note": "Заметка",
      "rpeChip": "RPE",
      "historyChip": "История",
      "more": "Другие действия",
      "addGroup": "Сгруппировать с другим упражнением",
      "cardioDuration": "Длительность",
      "cardioDurationPlaceholder": "Секунды",
      "cardioDistance": "Дистанция",
      "cardioWeight": "Вес",
      "cardioHr": "ЧСС ср.",
      "cardioCalories": "Калории",
      "cardioOptionalsShow": "Показать другие поля",
      "cardioOptionalsHide": "Скрыть другие поля",
      "dateEditor": "Дата и длительность",
      "dateLabel": "Дата",
      "startTimeLabel": "Начало",
      "endTimeLabel": "Конец",
      "durationLabel": "Длительность",
      "historyToggle": "История",
      "historyCount_one": "{{count}} тренировка",
      "historyCount_few": "{{count}} тренировки",
      "historyCount_many": "{{count}} тренировок",
      "historyCount_other": "{{count}} тренировок",
      "historyBest": "Лучшая",
      "historyCopy": "Копировать",
      "historyBodyweight": "{{reps}} повторений с весом тела",
      "historyEstimateHeader": "Оценка по похожему упражнению",
      "historyEstimatedFrom": "Из {{name}}",
      "historyNoEstimate": "Истории пока нет, и нет похожего упражнения для оценки.",
      "copyDialogTitle": "Копировать тренировку",
      "copyDialogBody": "Заменить незавершённые подходы или добавить к существующим?",
      "copyOverwrite": "Заменить",
      "copyAppend": "Добавить",
      "resumeTitle": "Возобновить тренировку?",
      "resumeBody": "Ты начал тренировку {{date}}, но не сохранил её. Возобновить или отменить?",
      "resumeContinue": "Возобновить",
      "resumeDiscard": "Отменить",
      "conflictTitle": "Тренировка продолжается",
      "conflictBody": "Вы уже записываете тренировку. Продолжите её или откройте, чтобы сохранить или отменить.",
      "nameLabel": "Название тренировки",
      "namePlaceholder": "Название: напр. Push…",
      "editNameA11y": "Изменить название тренировки",
      "setStateA11y": "подход {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "единица {{unit}}",
      "stepperPositive": "плюс",
      "stepperNegative": "минус",
      "historyCount": "{{n}} тренировок",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Легко",
      "effortMeterHard": "Тяжело",
      "effortWord": "Усилие",
      "holdSlotDone": "ГОТОВО",
      "holdSlotHeld": "ДЕРЖАЛ",
      "holdSlotDoneA11y": "{{time}} выполнено",
      "holdSlotFailedA11y": "{{time}}, не выполнено",
      "holdSlotHeldA11y": "{{time}} удержано",
      "effortMeterFail": "Fail",
      "effortQuestionRir": "Повторов в запасе?",
      "effortQuestionRpe": "Насколько тяжело?",
      "effortQuestionHint": "Открывает шкалу усилия — как она устроена и как её сменить",
      "effortMeterHintLog": "Также записывает подход как выполненный",
      "effortMeterHintRunning": "Остановит таймер и запишет подход",
      "effortMeterHintEdit": "Обновляет усилие этого записанного подхода",
      "effortMeterFailHintLog": "Записывает подход как невыполненный",
      "effortMeterFailHintEdit": "Переключает подход между выполненным и невыполненным",
      "effortMeterTapCta": "Нажмите, чтобы записать подход",
      "effortMeterStopCta": "Нажмите, чтобы остановить и записать",
      "effortNudgeOptOut": "Отключить напоминание",
      "effortNudgeOptOutHint": "Сначала спросит подтверждение. Снова включить можно в настройках.",
      "effortNudgeOptOutConfirmTitle": "Отключить это напоминание?",
      "effortNudgeOptOutConfirmBody": "Включить снова можно в любой момент в настройках.",
      "effortNudgeOptOutConfirmButton": "Отключить",
      "effortMeterAmrapDone": "Готово",
      "effortMeterAmrapHint": "Записывает подход до отказа — повторений не осталось",
      "amrapChip": "Максимум повторений",
      "burnPlus": "Burn+",
      "burnPlusChip": "Техника интенсивности Burn+ (дропсет / мио-повтор)",
      "effortLegendA11y": "Справка по шкале усилия",
      "rirLegendTitle": "RIR: повторений в запасе",
      "rirLegendBody": "0 = нет повторов в запасе\n1 = 1 повтор в запасе\n2 = 2 повтора\n3 = хороший запас\n4+ = легко / разминка",
      "rpeLegendTitle": "RPE: воспринимаемое усилие",
      "rpeLegendBody": "10 = нет повторов в запасе\n9 = 1 повтор в запасе\n8 = 2 повтора\n7 = хороший запас\n6 и меньше = легко / разминка",
      "timerStartCountdown": "Запустить обратный отсчёт",
      "timerStartCountup": "Запустить секундомер",
      "timerSettings": "Настройки таймера для этого упражнения",
      "holdHeaderHours": "ч",
      "holdHeaderMinutes": "мин",
      "holdHeaderSeconds": "с",
      "holdHours": "Часы",
      "holdMinutes": "Минуты",
      "holdSeconds": "Секунды",
      "holdSubTen": "-10 с",
      "holdAddTen": "+10 с",
      "holdCancel": "Отмена",
      "holdClockElapsedA11y": "прошло {{time}}",
      "holdClockOvertimeA11y": "{{time}} сверх цели",
      "holdClockPausedA11y": "{{label}}, на паузе",
      "holdClockRemainingA11y": "осталось {{time}}",
      "holdFlip": "Сменить направление",
      "holdExtraWeight": "Доп.",
      "lateralityTipUni": "UNI · запишите одну сторону; объём считается ×2.",
      "lateralityTipBi": "BI · билатеральная нагрузка; объём считается ×1.",
      "tabExercises": "Упражнения",
      "tabSuperset": "Суперсет",
      "pickerAddN": "Добавить {{n}}",
      "pickerAlreadyInWorkout": "Уже в этой тренировке",
      "pickerAlreadyInBlock": "Уже в этом блоке",
      "pickerPin": "В избранное",
      "pickerUnpin": "Убрать из избранного",
      "noteReadA11y": "Заметка к упражнению — нажмите, чтобы прочитать целиком",
      "prescriptionReadA11y": "Указание к подходу — нажмите, чтобы прочитать целиком",
      "helpToggle": "Справка — коснитесь чипа, чтобы узнать, что он делает",
      "tipAmrap": "Максимум повторений — доведите подход до технического отказа.",
      "tipBurnPlus": "Техники интенсивности — откройте Dropset или Myo-rep, чтобы продлить подход за пределы отказа.",
      "helpBanner": "Режим справки — коснитесь чипа, чтобы узнать, что он делает; коснитесь ⓘ для выхода.",
      "helpModeHint": "Режим справки включён — это объясняет, а не меняет настройку.",
      "targetsMore": "+{{count}} ещё",
      "targetEyebrow": "Цель"
    },
    "coachBanner": {
      "a11y": "{{count}} приглашений от тренера ожидают",
      "one": "1 приглашение от тренера",
      "many": "{{count}} приглашений от тренера",
      "action": "Открыть"
    },
    "coachEdges": {
      "empty": "Связей с тренером пока нет. Тренер может пригласить вас из веб-приложения."
    },
    "toxicDraft": {
      "banner": "Восстановлена повреждённая тренировка.",
      "viewJson": "Показать JSON",
      "sendSupport": "Отправить в поддержку",
      "dismiss": "Отменить",
      "close": "Закрыть",
      "jsonTitle": "Тренировка в карантине",
      "supportPrefix": "Повреждённый черновик автоматически обнаружен счётчиком запусков. JSON в карантине ниже.",
      "sentTitle": "Отправка в поддержку",
      "sentBody": "Данные восстановления отправлены.",
      "sendError": "Не удалось отправить. Тренировка остаётся в карантине."
    },
    "recovery": {
      "banner": "Восстановленная тренировка",
      "summary": "{{date}} · {{exercises}} упр. · {{done}}/{{total}} подходов выполнено",
      "saveAsNew": "Сохранить как новую",
      "discard": "Отклонить",
      "title": "Восстановленная тренировка",
      "openBody": "Эта тренировка была прервана и восстановлена. Проверьте подходы и нажмите «Сохранить», чтобы записать её как новую тренировку.",
      "open": "Открыть",
      "cancel": "Отмена",
      "liveBusy": "У вас есть незавершённая тренировка. Сохраните или отклоните её, прежде чем восстанавливать эту.",
      "discardTitle": "Отклонить восстановленную тренировку?",
      "discardBody": "Восстановленная тренировка будет удалена безвозвратно.",
      "discardConfirm": "Отклонить",
      "error": "Не удалось восстановить тренировку. Попробуйте ещё раз.",
      "merge": "Объединить…",
      "mergeTitle": "Объединить тренировку",
      "mergePrompt": "Выберите тренировку того же дня для объединения:",
      "noSameDay": "Нет тренировки того же дня для объединения. Используйте «Сохранить как новую».",
      "nothingToMerge": "Нет завершённых подходов для объединения. Используйте «Сохранить как новую»."
    },
    "group": {
      "title": "Сгруппировать упражнение",
      "close": "Закрыть",
      "standalone": "Отдельно",
      "supersetSection": "СУПЕРСЕТЫ",
      "circuitSection": "КРУГОВЫЕ",
      "supersetN": "Суперсет {{n}}",
      "circuitN": "Круговая {{n}}",
      "newSuperset": "+ Новый суперсет",
      "newCircuit": "+ Новая круговая",
      "groupCta": "+ Суперсет"
    },
    "webview": {
      "close": "Закрыть",
      "openExternal": "Открыть в браузере",
      "errorTitle": "Страница не загрузилась",
      "errorBody": "Нажмите ниже, чтобы открыть в системном браузере.",
      "fallbackErrorTitle": "Не удалось открыть браузер",
      "fallbackErrorBody": "Попробуй из другой сети."
    },
    "plates": {
      "title": "Расчёт блинов",
      "close": "Закрыть",
      "apply": "Применить",
      "targetLabel": "Цель",
      "barLabel": "Гриф",
      "perSide": "На сторону: {{kg}} кг",
      "barOnly": "Только гриф — блины не нужны.",
      "pairs_one": "{{count}} пара",
      "pairs_few": "{{count}} пары",
      "pairs_many": "{{count}} пар",
      "pairs_other": "{{count}} пар",
      "plates_one": "{{count}} блин",
      "plates_few": "{{count}} блина",
      "plates_many": "{{count}} блинов",
      "plates_other": "{{count}} блинов",
      "loadedEnd": "Нагруженный конец: {{kg}} кг",
      "landmineHint": "Лендмайн: блины ставятся только на свободный конец, второй закреплён на полу.",
      "remainder": "Не хватает {{kg}} кг — инвентарь не совпадает точно.",
      "belowBar": "Цель меньше веса грифа.",
      "invalid": "Введите корректный вес.",
      "inventoryShow": "Изменить инвентарь блинов",
      "inventoryHide": "Скрыть инвентарь блинов",
      "inventoryTitle": "Доступные пары",
      "pairsIncrement": "Добавить пару",
      "pairsDecrement": "Убрать пару",
      "signLabel": "ЗНАК EXTRA",
      "signAdd": "+ С отягощением",
      "signAssist": "− С помощью"
    },
    "restTimerScreen": {
      "title": "Таймеры",
      "back": "Назад"
    },
    "licenses": {
      "title": "Лицензии open source",
      "back": "Назад",
      "headlineIntro": "JackedLogs опирается на небольшой набор библиотек, которые во многом определяют приложение. Нажми на строку, чтобы открыть проект — и подумай о поддержке тех, которыми пользуешься чаще всего.",
      "coreSection": "Основные библиотеки ({{count}})",
      "viewAllTitle": "Показать все пакеты",
      "viewAllSub": "Полные атрибуции для {{count}} пакетов, включённых в APK, сгруппированных по проектам.",
      "allTitle": "Все пакеты ({{count}})",
      "searchAll": "Поиск по имени, группе, лицензии или автору",
      "groupOther": "Прочие пакеты",
      "empty": "Нет пакетов, соответствующих поиску.",
      "footer": "Создано {{date}}",
      "openErrorTitle": "Не удаётся открыть ссылку"
    },
    "share": {
      "newPR": "НОВЫЙ ПР",
      "topLifts": "ТОП УПРАЖНЕНИЯ",
      "durationMinute": "мин.",
      "durationHour": "ч",
      "durationMinuteShort": "мин.",
      "footerSets": "подходов",
      "footerDensitySuffix": "/мин",
      "fallbackLabel": "Общий Объём",
      "timeLabel": "Общее Время",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Импульс",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Калории",
      "blockEffort": "Нагрузка",
      "effortHr": "{{avg}} сред. · {{peak}} пик уд/мин",
      "effortHrMax": "{{pct}}% от макс. ЧСС",
      "shareTitle": "Тренировка JackedLogs",
      "shareErrorTitle": "Не удалось поделиться",
      "headlineLabelPR": "НОВЫЙ E1RM",
      "headlineLabelDelta": "БОЛЬШОЙ СКАЧОК +{{delta}}",
      "headlineLabelSolid": "ХОРОШАЯ ТРЕНИРОВКА",
      "headlineSolidValue": "{{volume}} за {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} подходов",
      "blockTopLifts": "Топ упражнения",
      "fromSet": "из {{weight}} × {{reps}}",
      "blockVolume": "Объём",
      "blockDuration": "Длительность",
      "blockDensity": "Плотность",
      "barsTitle": "Нагрузка по мышцам",
      "bodyTitle": "Задействованные мышцы",
      "sharing": "Подготовка…",
      "shareCta": "Поделиться карточкой тренировки",
      "done": "Готово",
      "summaryTitle": "Тренировка сохранена"
    },
    "common": {
      "back": "Назад",
      "save": "Сохранить",
      "cancel": "Отмена",
      "close": "Закрыть"
    },
    "account": {
      "title": "Аккаунт",
      "navSub": "Имя, пароль, экспорт, удаление, выход",
      "nameLabel": "ИМЯ",
      "namePlaceholder": "Ваше имя",
      "saved": "Сохранено",
      "passwordLabel": "СМЕНА ПАРОЛЯ",
      "currentPassword": "Текущий пароль",
      "newPassword": "Новый пароль",
      "confirmPassword": "Подтвердите новый пароль",
      "passwordChanged": "Пароль изменён.",
      "passwordSubmit": "Обновить пароль",
      "deleteNeedsConnection": "Для удаления аккаунта нужно соединение. Подключитесь и повторите попытку — этот запрос никогда не сохраняется на потом."
    },
    "prefs": {
      "title": "Единицы и отображение",
      "navSub": "Единицы, язык, подсказки",
      "unitsLabel": "Единицы",
      "unitsHelp": "Единица веса по умолчанию для новых подходов. Её всё равно можно изменить для каждой строки в логгере.",
      "weekStartLabel": "Неделя начинается с",
      "weekStartHelp": "День, с которого начинается твоя тренировочная неделя. Недельные цели по мышцам считаются с этого дня.",
      "unitsKg": "Килограммы (кг)",
      "unitsLb": "Фунты (lb)",
      "glucoseUnitsLabel": "Единицы глюкозы",
      "glucoseUnitsHelp": "Как глюкоза показывается и вводится. Хранится одинаково.",
      "glucoseMmol": "ммоль/л",
      "glucoseMgdl": "мг/дл",
      "themePaletteLabel": "Палитра темы",
      "themePaletteHelp": "Выберите цветовую палитру для всего приложения.",
      "themeModeLabel": "Оформление",
      "themeModeHelp": "Следовать системной настройке или задать светлую либо тёмную.",
      "themeMode": {
        "system": "Системная",
        "light": "Светлая",
        "dark": "Тёмная"
      }
    },
    "home": {
      "targetsTopPatterns": "Основные паттерны",
      "targetsSummary": "{{on}} из {{total}} в цели",
      "targetsHint": "Закрепите программу с недельными целями, чтобы оценивать их.",
      "targetsZoneOnTarget": "в цели",
      "targetsZoneOver": "выше",
      "targetsZoneUnder": "в процессе",
      "targetsNoCoverage": "нет в плане",
      "targetsPrescribed": "план {{n}}",
      "targetsEmptyTitle": "Целей пока нет",
      "targetsEmptySub": "Задайте, сколько хотите тренировать каждую мышцу в неделю. Ваш план будет работать на это; счётчик на главной покажет, где вы находитесь.",
      "targetsEmptyCta": "Задать цели",
      "weekEyebrow": "На этой неделе",
      "weeklyTitle": "Последние 7 дней",
      "weeklySessions": "Тренировки",
      "weeklyVolume": "Объём",
      "weeklyA11y": "{{sessions}} тренировок, объём {{volume}}",
      "viewProgress": "Открыть прогресс",
      "badgesTitle": "Значки",
      "newsTitle": "Новости",
      "newsEmpty": "Новости приложения появятся здесь.",
      "prPrev": "Предыдущий рекорд",
      "prNext": "Следующий рекорд",
      "prPosition": "Рекорд {{n}} из {{total}}",
      "eyebrow": "СЕГОДНЯ",
      "blankTitle": "Готовы тренироваться?",
      "blankLoading": "Загрузка плана…",
      "blankBody": "Сейчас нет активной программы. Начните пустую тренировку или нажмите ＋, чтобы запланировать.",
      "newWorkout": "Новая тренировка",
      "programMeta": "{{program}} · Неделя {{week}}",
      "morePreview": " +ещё {{count}}",
      "startToday": "▶ Начать тренировку",
      "blankInstead": "Начать пустую тренировку",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} повторений с весом тела",
      "prToday": "Сегодня",
      "prDaysAgo": "{{n}} дн назад",
      "weightTitle": "Вес тела",
      "weightSaved": "Сохранено ✓",
      "weightCurrent": "Последний: {{value}} {{unit}}",
      "weightNone": "Записывайте вес, чтобы видеть динамику.",
      "weightSave": "Сохранить",
      "repeatWorkout": "Повторить тренировку",
      "form": {
        "title": "Готовность",
        "ready": "Готов",
        "caution": "Осторожно",
        "rest": "Отдых",
        "reasonNoData": "Запишите тренировку, чтобы отслеживать готовность.",
        "reasonWellRecovered": "Хорошо отдохнули после прошлой тренировки — можно поднажать.",
        "reasonBalanced": "Ваша нагрузка выглядит сбалансированной.",
        "reasonFreshStart": "Вы возвращаетесь — начните спокойно и наберите базу.",
        "reasonShortRest": "Тренировки подряд — следите за восстановлением.",
        "reasonHighFrequency": "Неделя с высоким объёмом — подумайте о более лёгком дне.",
        "reasonLoadSpike": "Нагрузка резко выросла по сравнению со средней за последнее время.",
        "reasonLongGap": "Давно не тренировались — начните легко, чтобы войти в форму."
      },
      "glucoseSave": "Сохранить",
      "weightSaveA11y": "Сохранить вес тела",
      "glucoseSaveA11y": "Сохранить уровень глюкозы"
    },
    "superset": {
      "startingWith": "Начать суперсет с",
      "joinExisting": "В существующий",
      "pairInWorkout": "Объединить (в этой тренировке)",
      "templates": "Сохранённые суперсеты",
      "templateInsertHint": "Вставить этот суперсет; удерживайте для удаления",
      "templateDeleteBody": "Удалить этот сохранённый суперсет?",
      "createCta": "Создать суперсет ({{n}})",
      "cueCycle": "{{group}}, упражнение {{pos}} из {{total}}. Нажмите, чтобы перейти к {{next}}.",
      "cueStatic": "{{group}}, упражнение {{pos}} из {{total}}",
      "menuOpen": "Опции суперсета",
      "menuSaveTemplate": "Сохранить как шаблон",
      "menuAddExercise": "Добавить упражнение",
      "menuMoveUp": "Вверх",
      "menuMoveDown": "Вниз",
      "menuRemoveMember": "Убрать это упражнение",
      "menuSplit": "Распустить суперсет",
      "namePlaceholder": "Название суперсета (необязательно)"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Настройки таймера отдыха по умолчанию",
      "globalLabel": "Глобальное значение",
      "globalUnset": "Не задано — используется {{n}}с",
      "customLabel": "Упражнения с индивидуальной настройкой",
      "customEmpty": "Нет индивидуальных значений. Откройте баннер отдыха в логгере и нажмите ⚙, чтобы задать.",
      "customRemoveA11y": "Удалить индивидуальный отдых для {{name}}",
      "clearGlobal": "Сбросить"
    },
    "hints": {
      "title": "Подсказки",
      "label": "Показывать подсказки",
      "help": "Нажмите на заголовок столбца, чтобы узнать его значение. Выключите, чтобы скрыть подсказки."
    },
    "effortNudge": {
      "label": "Напоминание об усилии",
      "help": "Редкий мягкий импульс на шкале усилия, пока подход ждёт записи."
    },
    "inWorkoutMeter": {
      "label": "Счётчик целей в тренировке",
      "help": "Полоса вверху карточки упражнения с недельной целью для мышц, которые ты тренируешь."
    },
    "audio": {
      "title": "Звук",
      "soundLabel": "Звук таймера",
      "soundHelp": "Воспроизводится по окончании таймера отдыха.",
      "vibrationLabel": "Вибрация",
      "vibrationHelp": "Вибрирует по окончании таймера отдыха.",
      "previewButton": "Прослушать",
      "pickerTitle": "Выбрать звук",
      "pickerCancel": "Отмена",
      "category": {
        "serious": "Обычные",
        "fun": "Весёлые"
      },
      "soundOptions": {
        "none": "Без звука",
        "chime_crisp": "Колокольчик",
        "ding_dong": "Дин-дон",
        "meditation_bell": "Поющая чаша",
        "tada_fanfare": "Та-да",
        "cartoon_boing": "Боинг",
        "ah_yeah": "Ага!"
      }
    },
    "timerDefaults": {
      "range": "Введите {{min}}–{{max}} с",
      "globalTitle": "Общие значения",
      "restGlobal": "Таймер отдыха",
      "holdGlobal": "Таймер удержания",
      "customLabel": "Настройки по упражнению",
      "customEmpty": "Пока нет настроек по упражнению. Нажмите + Добавить.",
      "unset": "Не задано — {{n}} с",
      "add": "+ Добавить",
      "editRestA11y": "Изменить отдых для {{name}}",
      "editHoldA11y": "Изменить удержание для {{name}}",
      "editA11y": "Изменить таймеры для {{name}}",
      "isDefault": "по умолч.",
      "equalsDefaultHint": "Значение, равное общему по умолчанию, не сохраняется как переопределение.",
      "remove": "Удалить"
    },
    "backend": {
      "section": "Бэкенд",
      "title": "Бэкенд",
      "navSub": "Выберите, куда пишет эта сборка",
      "pickLabel": "Писать мои данные в",
      "pickHelp": "Только dev-сборка. У каждого бэкенда своя сессия, свои очереди и свой черновик тренировки — переключение не трогает другой.",
      "stageProduction": "ПРОДАКШН",
      "stageLab": "ЛАБОРАТОРИЯ",
      "liveLabel": "ЗАПИСЬ ИДЁТ В",
      "liveChecking": "Проверка…",
      "liveUnknown": "Неизвестно — бэкенд не ответил",
      "liveNotProduction": "Здесь нет ваших настоящих тренировок.",
      "confirmTitle": "Сменить бэкенд?",
      "confirmBody": "Приложение перезагрузится на {{stage}}. Там может потребоваться вход, а кэшированные списки будут сброшены.",
      "confirmCta": "Сменить",
      "blockedByQueue": "Не переключено: часть записей ещё не ушла. Вернитесь в сеть и дайте очередям опустошиться."
    },
    "animations": {
      "cellularLabel": "Загружать анимации без Wi-Fi",
      "cellularHelp": "По умолчанию выключено. Анимации есть в любом случае: это лишь разрешает приложению загружать их заранее по мобильной сети, примерно 20-30 МБ на программу."
    }
  },
  "web": {
    "crash": {
      "body": "В приложении произошла непредвиденная ошибка. Ваши сохранённые данные в безопасности — перезагрузите, чтобы продолжить.",
      "reload": "Перезагрузить"
    },
    "postSession": {
      "headlineLabelPR": "НОВЫЙ E1RM",
      "headlineLabelDelta": "БОЛЬШОЙ СКАЧОК +{{delta}}",
      "headlineLabelSolid": "ХОРОШАЯ ТРЕНИРОВКА",
      "headlineSolidValue": "{{volume}} за {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} подходов",
      "blockE1rm": "E1RM",
      "fromSet": "из {{weight}} × {{reps}}",
      "blockVolume": "Объём",
      "blockDuration": "Длительность",
      "blockDensity": "Плотность",
      "barsTitle": "Нагрузка по мышцам",
      "bodyTitle": "Задействованные мышцы",
      "sharing": "Подготовка…",
      "shareCta": "Поделиться карточкой тренировки"
    }
  },
  "muscle": {
    "quadriceps": "Квадрицепсы",
    "hamstrings": "Бицепсы бёдер",
    "glutes": "Ягодицы",
    "adductors": "Приводящие",
    "abductors": "Отводящие",
    "calves": "Икры",
    "core": "Корпус",
    "obliques": "Косые",
    "erectors": "Поясница",
    "pectoralis": "Грудь",
    "anterior-delts": "Передние дельты",
    "lateral-delts": "Средние дельты",
    "triceps": "Трицепсы",
    "lats": "Широчайшие",
    "rhomboids": "Ромбовидные",
    "rear-delts": "Задние дельты",
    "traps": "Трапеции",
    "biceps": "Бицепсы",
    "forearms": "Предплечья"
  },
  "experience": {
    "menuLabel": "Активный профиль",
    "athlete": "Спортсмен",
    "coach": "Тренер",
    "admin": "Админ"
  },
  "composer": {
    "targetAxisExercise": "Упражнение",
    "targetKeyExercise": "Упражнение",
    "targetRefAvg": "~{{n}}/нед сред.",
    "targetRefLast": "посл. нед {{n}}",
    "targetRefNone": "Нет данных за последние 4 недели",
    "targetRefProgram": "программа задаёт ~{{n}}/нед",
    "targetUseAvg": "Взять среднее",
    "targetUseProgram": "Взять из программы",
    "projectionTitle": "Распределение целей",
    "projectionWeek": "Неделя {{n}}",
    "projectionContext": "Подходы / нагрузка, заданные программой на неделе {{n}}.",
    "projectionTarget": "Цель",
    "projectionWeekTotal": "Нед.",
    "projectionRamp": "Цикл",
    "projectionWeekShort": "Н{{n}}",
    "projectionEmpty": "Не запланировано",
    "targetsTitle": "Недельные цели",
    "targetsEmptyTitle": "Нет недельных целей",
    "targetsEmptySub": "Добавьте цель, чтобы включить шкалу уровня.",
    "targetAdd": "Добавить цель",
    "targetRemove": "Удалить цель {{name}}",
    "targetCollapse": "Свернуть",
    "targetAxis": "Ось",
    "targetAxisMuscle": "Мышца",
    "targetMetric": "Метрика",
    "targetMetricHardSets": "Тяжёлые подходы",
    "targetMetricTonnage": "Тоннаж",
    "targetMetricReps": "Повт.",
    "prescriptionEyebrow": "Предписание",
    "prescriptionSub": "Что этот блок предписывает каждую неделю, в сравнении с твоими целями.",
    "targetKeyMuscle": "Мышца",
    "targetValue": "Недельная цель",
    "targetUnitHardSets": "тяж. подходов",
    "targetUnitTonnage": "кг",
    "targetUnitReps": "повт.",
    "targetBand": "±{{pct}} %",
    "targetNotScored": "пока не в шкале",
    "targetNotScoredNote": "Этот тип цели пока не учитывается в шкале уровня.",
    "targetBandLabel": "Допуск",
    "targetBandAsym": "−{{lo}}% / +{{hi}}%",
    "targetBandBelow": "Процент ниже цели",
    "targetBandAbove": "Процент выше цели",
    "targetBandRange": "Ниже 0–99%, выше 0% или больше.",
    "compose": "Составить",
    "preview": "Предпросмотр",
    "addExercises": "Добавить упражнения",
    "add": "Добавить",
    "update": "Обновить",
    "editingBlockDay": "Редактируется Д{{d}} — обновление применяется к этому дню (отметьте другие дни, чтобы применить и к ним)",
    "editingRampDay": "Недельная прогрессия в Д{{d}} — обновление применяется к выбранным неделям, только этот день",
    "segments": "Сегменты",
    "rampSwitchHint": "Сначала обновите или отмените, затем меняйте сегмент",
    "setupHint": "Задайте начальную форму — дни можно добавить или удалить, а недели изменить позже в редакторе.",
    "repsHint": "Повторы «5+» = AMRAP: минимум 5, дальше сколько сможете.",
    "repsHintA11y": "Как записываются повторения",
    "addingWeek": "Новая неделя W{{n}} — обновление добавит её к этому упражнению",
    "cloneWeek": "Клонировать неделю…",
    "cloneWeekFrom": "Из",
    "cloneWeekApply": "Клонировать",
    "cloneWeekConflict": "{{name}} уже имеет содержимое в W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Нечего клонировать — выберите заполненную неделю-источник и хотя бы одну цель",
    "cloneDayEmpty": "В этом дне нечего клонировать",
    "editingWeekDay": "Редактируется только W{{n}} в Д{{d}} — обновление отделит её от сегмента",
    "perWeek": "По неделям",
    "dupExercise": "{{name}} уже есть в D{{day}} в выбранных неделях",
    "cloneDay": "Клонировать D{{n}} в…",
    "cloneDayTarget": "В",
    "days": "Дни",
    "weeks": "Недели",
    "setNote": "Заметка подхода",
    "removeExercise": "Убрать упражнение",
    "replaceExercise": "Заменить упражнение",
    "clone": "Клонировать",
    "remove": "Удалить",
    "removeConfirm": "Подтвердить? ({{n}} ячеек)",
    "verbatim": "Расширенный слот (мульти-вариант) — сохраняется как есть, здесь не редактируется",
    "metaWeeks": "{{n}} недель",
    "metaDays": "{{n}} тренировочных дней",
    "gridToggle": "Сетка интенсивности",
    "dayPickLabel": "День",
    "addDay": "Добавить день",
    "removeDay": "Удалить день D{{n}}",
    "removeDayConfirm": "Подтвердить — удалить день D{{n}}?",
    "shrinkWeeksConfirm": "Нажми − ещё раз, чтобы удалить неделю {{n}} и её подходы.",
    "dayEmpty": "В этом дне пока нет упражнений. Добавьте одно, чтобы начать.",
    "checkEmptyCell": "W{{w}}·D{{d}} без упражнений",
    "checkPctNoMax": "{{name}} использует %MAX без сохранённого MAX",
    "exerciseNote": "Заметка к упражнению",
    "exerciseNotePlaceholder": "Заметка к упражнению (видна при логировании)",
    "panelHint": "Нажмите упражнение: изменить, клонировать, убрать",
    "warnLine_one": "{{count}} предупреждение",
    "warnLine_few": "{{count}} предупреждения",
    "warnLine_many": "{{count}} предупреждений",
    "warnLine_other": "{{count}} предупреждения",
    "adjacencyWarnLine_one": "{{count}} предупреждение о восстановлении мышц",
    "adjacencyWarnLine_few": "{{count}} предупреждения о восстановлении мышц",
    "adjacencyWarnLine_many": "{{count}} предупреждений о восстановлении мышц",
    "adjacencyWarnLine_other": "{{count}} предупреждения о восстановлении мышц",
    "adjacencyWarnItem": "{{muscle}}: нагрузка в смежные дни ({{count}}×)",
    "publishChecklist": "Открытые предупреждения (публиковать всё равно можно)",
    "publishClean": "Нет открытых предупреждений."
  },
  "gym": {
    "setPlace": "Где?",
    "whichPlace": "Где ты тренируешься?",
    "newPlace": "Добавить место",
    "fallback": "По умолчанию",
    "chipA11y": "Место тренировки",
    "footnote": "Определяет порядок показа. Тренеру не передаётся.",
    "namePlaceTitle": "Назовите это место",
    "namePlaceHint": "Название места",
    "namePlaceSave": "Использовать это место",
    "pinPlace": "Сделать {{place}} местом по умолчанию",
    "unpinPlace": "Убрать {{place}} как место по умолчанию",
    "pinHint": "Запоминает это как место, где ты обычно тренируешься.",
    "unpinHint": "Забывает твоё место по умолчанию.",
    "pinErrorTitle": "Не сохранено",
    "pinErrorBody": "Твоё место по умолчанию не изменилось."
  }
}
